import React, { useState, useEffect, useRef, Fragment, useMemo } from "react";
import { useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { requestApi, requestPutFormData, requestFormData } from "../../../request-api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import Dropdown from "../../layouts/dropdown/Dropdown";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { API_URL } from "../../../config";
import {
  endOfLocalDay,
  isLocalDateInRange,
  startOfLocalDay,
} from "../../../helpers/complianceDashboard";

function Active() {
  const location = useLocation();
  const [isOpen3, setIsOpen3] = useState(false);
  const dropdownRef1 = useRef(null);
  const dateDropdownRef = useRef(null);
  const [showModall, setShowModall] = React.useState(false);
  const [complianceData, setComplianceData] = React.useState(null);
  const [showDropdown1, setShowDropdown1] = useState(false);
  const dropdownRef2 = useRef(null);

  const toggleDropdown1 = () => {
    setShowDropdown1((prev) => !prev);
  };

  // Close on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef1.current &&
        !dropdownRef1.current.contains(event.target)
      ) {
        setIsOpen3(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dateDropdownRef.current &&
        !dateDropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef2.current &&
        !dropdownRef2.current.contains(event.target)
      ) {
        setShowDropdown1(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const [loading, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [reports, setReports] = useState([]);
  const [filteredReports, setFilteredReports] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedStatus, setSelectedStatus] = useState([]);
  const statusOptions = [
    "Complied",
    "Not Complied",
    "Partial Complied",
    "Not Applicable",
    "Not Updated",
  ];

  useEffect(() => {
    if (location?.state) {
      const {
        status,
        selectedStatus: passedStatus,
        selectedCompany: passedCompany,
        selectedCompanies: passedCompanies,
        selectedLocation: passedLoc,
        filterDateWise: passedDateWise,
        activeFilter: passedActiveFilter,
        applyDateFilter,
      } = location.state;

      if (passedStatus && passedStatus.length > 0) {
        setSelectedStatus(passedStatus);
      } else if (status) {
        setSelectedStatus([status]);
      }

      const compToUse = passedCompanies || passedCompany;
      if (compToUse && (Array.isArray(compToUse) ? compToUse.length > 0 : Boolean(compToUse))) {
        setSelectedCompanies(compToUse);
      } else {
        setSelectedCompanies("");
      }

      if (passedLoc && (Array.isArray(passedLoc) ? passedLoc.length > 0 : Boolean(passedLoc))) {
        setSelectedLocation(passedLoc);
      } else {
        setSelectedLocation("");
      }

      if (applyDateFilter && passedDateWise && passedDateWise.startDate && passedDateWise.endDate) {
        setFilterDateWise({
          startDate: new Date(passedDateWise.startDate),
          endDate: new Date(passedDateWise.endDate),
        });
        if (passedActiveFilter) {
          setActiveFilter(passedActiveFilter);
        }
      } else {
        setFilterDateWise({
          startDate: null,
          endDate: null,
        });
        setActiveFilter("");
      }
    }
  }, [location?.state]);


  // const [locationSearchName, setLocationSearchName] = useState('');
  const [companies, setCompanies] = useState([]);
  const [locations, setLocations] = useState([]);
  const [activeFilter, setActiveFilter] = useState("This Month");
  const [sortBy, setSortBy] = useState("none");
  const [selectedAct, setSelectedAct] = useState([]);
  const [actSearchName, setActSearchName] = useState("");
  const [compliance, setCompliance] = useState([]);
  const [format, setFormat] = useState("pdf");
  const [selectedSubBranches, setSelectedSubBranches] = useState([]);
  const [availableSubBranches, setAvailableSubBranches] = useState([]);
  const [period, setPeriod] = useState("Monthly");
  const [showAddComplianceModal, setShowAddComplianceModal] = useState(false);
  const [addFormData, setAddFormData] = useState({
    company_name: "",
    branch_id: "",
    location: "",
    legislation_name: "",
    sub_branch: "",
    compliance: "",
    compliance_description: "",
    provision: "",
    compliance_categorization: "",
    compliance_type: "",
    penalty_type: "",
    penalty_description: "",
    summary_of_observation: "",
    management_remark: "",
    proof_mandatory: "",
    criticality: "",
    auditor: "",
    approver: "",
    current_compliance_status: "",
    due_date: "",
    open_closed: "",
  });
  const [addFormErrors, setAddFormErrors] = useState({});

  const [totals, setTotals] = useState({
    totalCompany: 0,
    overdueActions: 0,
    dueActions: 0,
    totalActions: 0,
    totalScore: 0,
  });
  const [visibleColumns, setVisibleColumns] = useState({
    srNo: true,
    entity: true,
    branchId: true,
    acts: true,
    compDesc: true,
    dateOfCompliance: true,
    dueDate: true,
    auditor: true,
    action: true,
  });
  const visibleColumnCount = Object.values(visibleColumns).filter(Boolean).length;
  const toggleColumn = (colKey) => {
    setVisibleColumns((prev) => ({
      ...prev,
      [colKey]: !prev[colKey],
    }));
  };
  const handleShowAllColumns = () => {
    setVisibleColumns((prev) =>
      Object.keys(prev).reduce((acc, key) => {
        acc[key] = true;
        return acc;
      }, {})
    );
  };

  // Initialize with current month dates
  const getCurrentMonthDates = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);
    return { start, end };
  };

  const { start: defaultStart, end: defaultEnd } = getCurrentMonthDates();
  const [filterDateWise, setFilterDateWise] = useState({
    startDate: defaultStart,
    endDate: defaultEnd,
  });
  const formats = [
    { label: "Pdf", icon: "bi-file-earmark-pdf", value: "pdf" },
    { label: "Excel", icon: "bi-file-earmark-excel", value: "excel" },
  ];
  const periods = ["Monthly", "Quarterly", "Semi-Annually", "Annually"];

  const [formData, setFormData] = useState({
    complianceStatus: "",
    proofFile: "",
    proofLink: "",
    comment: "",
    description: "",
    reason: "",
    criticality: "",
    period: "",
  });

  const [existingProofFile, setExistingProofFile] = useState(null);

  // Helper function to construct complete file URL
  const getCompleteFileUrl = (filePath) => {
    if (!filePath) return null;
    // If it's already a complete URL, return as is
    if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
      return filePath;
    }
    // If it's a relative path, prepend API_URL
    return `${API_URL}/${filePath.replace(/^\//, '')}`;
  };

  const [formErrors, setFormErrors] = useState({
    complianceStatus: "",
    proofFile: "",
    proofLink: "",
    comment: "",
    description: "",
    reason: "",
    criticality: "",
    period: "",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredReports.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredReports.length / itemsPerPage);
  const visiblePages = 5;
  const dropdownRef = useRef(null);
  let startPage = Math.max(1, currentPage - Math.floor(visiblePages / 2));
  let endPage = startPage + visiblePages - 1;
  const isProofMandatory = compliance?.proof_mandatory === "Yes";

  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - visiblePages + 1);
  }

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  useEffect(() => {
    fetchReports();
  }, []);

  useEffect(() => {
    let filtered = [...reports];

    // Apply date filter
    if (filterDateWise.startDate && filterDateWise.endDate) {
      filtered = filtered.filter((item) =>
        isLocalDateInRange(item.dueDate, filterDateWise.startDate, filterDateWise.endDate)
      );
    }

    if (selectedCompanies.length > 0) {
      filtered = filtered.filter((item) =>
        selectedCompanies.includes(item.companyName)
      );
    }
    if (selectedStatus.length > 0) {
      filtered = filtered.filter((item) =>
        selectedStatus.includes(item.currentstatus)
      );
    }


    if (selectedLocation.length > 0) {
      filtered = filtered.filter((item) =>
        selectedLocation.includes(item.location)
      );
    }
    //   if (
    //   selectedSubBranches.length > 0 &&
    //   !selectedSubBranches.includes(item.sub_branch)
    // ) {
    //   return false;
    // }

    if (selectedSubBranches.length > 0) {
      filtered = filtered.filter((item) =>
        selectedSubBranches.includes(item.sub_branch)
      );
    }

    if (selectedAct.length > 0) {
      filtered = filtered.filter((item) => selectedAct.includes(item.act));
    }

    if (sortBy !== "none") {
      filtered = sortReports(filtered, sortBy);
      console.log("filted report", filtered);
    }

    setFilteredReports(filtered);
    setCurrentPage(1);
  }, [
    reports,
    filterDateWise,
    selectedCompanies,
    selectedLocation,
    selectedSubBranches,
    selectedAct,
    selectedStatus,
    sortBy,
  ]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    if (isOpen1) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen1]);

  const validateForm = () => {
    const errors = {};
    const status = formData.complianceStatus;
    const isProofMandatory = compliance?.proof_mandatory === "Yes";

    if (!status) {
      errors.complianceStatus = "Please select a compliance status.";
    }

    // ✅ Conditional Proof Validation
    if (isProofMandatory) {
      if (!formData.proofFile && !formData.proofLink && !existingProofFile?.name) {
        errors.proofFile = "Proof file or link is required.";
      }

      if (formData.proofFile) {
        const allowedTypes = [
          "application/pdf",
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "image/png",
          "image/jpeg",
        ];

        if (!allowedTypes.includes(formData.proofFile.type)) {
          errors.proofFile =
            "Only PDF, Excel (.xls, .xlsx), PNG, JPG, or JPEG files are allowed.";
        } else if (formData.proofFile.size > 10 * 1024 * 1024) {
          errors.proofFile = "File size must be less than 10MB.";
        }
      }
    }

    // ✅ Status-based validations
    if (status === "Complied") {
      if (!formData.comment) {
        errors.comment = "Please enter a comment.";
      }
      if (!formData.description) {
        errors.description = "Please enter a description.";
      }
    }

    if (status === "Partial Complied") {
      if (!formData.reason) {
        errors.reason = "Please enter a reason.";
      }
      if (!formData.comment) {
        errors.comment = "Please enter a comment.";
      }
    }

    if (status === "Not Applicable") {
      if (!formData.description) {
        errors.description = "Please enter a description.";
      }
    }

    if (status === "Not Complied") {
      if (!formData.criticality) {
        errors.criticality = "Please select the criticality.";
      }
      if (!formData.reason) {
        errors.reason = "Please enter a reason.";
      }
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "complianceStatus") {
      setFormData({
        complianceStatus: value,
        proofFile: "",
        proofLink: "",
        comment: "",
        description: "",
        reason: "",
        criticality: "",
      });
      setFormErrors((prev) => ({
        ...prev,
        complianceStatus: "",
      }));
    } else if (name === "proofFile") {
      setFormData((prev) => ({
        ...prev,
        [name]: files[0],
      }));
      setFormErrors((prev) => ({
        ...prev,
        proofFile: "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const clearForm = () => {
    setFormData({
      complianceStatus: "",
      proofFile: null,
      proofLink: "",
      comment: "",
      description: "",
      reason: "",
      criticality: "",
      period: "",
    });
    setExistingProofFile(null);
  };

  const fetchReports = async () => {
    setLoading(true);

    try {
      const res = await requestApi(`/report/reportscomp`, {
        method: "get",
      });

      console.log("DEBUG fetched response:", res);

      if (res.length > 0) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const reports = res;

        const _companies = [...new Set(reports.map((r) => r.companyName))];
        const _locations = [...new Set(reports.map((r) => r.location))];
        const uniqueSubBranches = [
          ...new Set(reports.map((r) => r.sub_branch).filter(Boolean)),
        ];
        setAvailableSubBranches(uniqueSubBranches);

        console.log("DEBUG unique companies:", _companies);
        console.log("DEBUG unique locations:", _locations);

        const isValidDate = (dateStr) => {
          const date = new Date(dateStr);
          return !isNaN(date.getTime());
        };

        const isBeforeToday = (dateStr) => {
          if (!isValidDate(dateStr)) return false;
          const date = new Date(dateStr);
          date.setHours(0, 0, 0, 0);
          return date < today;
        };

        const isTodayOrFuture = (dateStr) => {
          if (!isValidDate(dateStr)) return false;
          const date = new Date(dateStr);
          date.setHours(0, 0, 0, 0);
          return date >= today;
        };

        const overdueReports = reports.filter((r) => isBeforeToday(r.dueDate) && String(r.currentstatus || "")
          .trim()
          .toLowerCase() !== "complied");
        //const dueReports = reports.filter((r) => isTodayOrFuture(r.dueDate));
        const dueReports = reports.filter(
          (r) =>
            isTodayOrFuture(r.dueDate) &&
            String(r.currentstatus || "")
              .trim()
              .toLowerCase() !== "complied"
        );

        console.log("DEBUG overdue reports count:", overdueReports.length);
        console.log(
          "DEBUG due today or future reports count:",
          dueReports.length
        );

        const overdueCount = overdueReports.length;
        const dueCount = dueReports.length;
        const totalActions = overdueCount + dueCount ;

        const compiledCount = reports.filter(
          (r) =>
            String(r.currentstatus || "")
              .trim()
              .toLowerCase() === "complied"
        ).length;
        const totalReports = reports.length;

        console.log("DEBUG compiled overdue count:", totalReports);

        const overdueScorePercentage =
          totalReports > 0
            ? ((compiledCount / totalReports) * 100).toFixed(2)
            : "0.00";

        const totalScoreDisplay = `${overdueScorePercentage}/100`;

        console.log("DEBUG overdueScorePercentage:", overdueScorePercentage);
        console.log("DEBUG totalScoreDisplay:", totalScoreDisplay);

        setCompanies(_companies);
        setLocations(_locations);

        setTotals({
          totalCompany: _companies.length.toString().padStart(2, "0"),
          overdueActions: overdueCount.toString().padStart(2, "0"),
          dueActions: dueCount.toString().padStart(2, "0"),
          totalActions: totalActions.toString().padStart(2, "0"),
          totalScore: totalScoreDisplay,
        });

        setReports(reports);
      } else {
        toast.warning("No data found!");
        console.log("DEBUG no data found");
      }
    } catch (err) {
      console.error("Error fetching reports:", err);
      toast.error(err?.data || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const filterByDueType = (type) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const isValidDate = (dateStr) => {
      const date = new Date(dateStr);
      return !isNaN(date.getTime());
    };

    const filtered = reports.filter((report) => {
      if (!isValidDate(report.dueDate)) return false;

      const dueDate = new Date(report.dueDate);
      dueDate.setHours(0, 0, 0, 0);

      if (type === "overdue") {
        // Exclude "Complied" from overdue
        return dueDate < today && report.currentstatus !== "Complied";
      }

      if (type === "due") {
        // Due today/future & not complied
        return dueDate >= today && report.currentstatus !== "Complied";
      }

      return true;
    });

    setFilteredReports(filtered);
    setCurrentPage(1); // Reset to first page
  };

  const toggleDropdown = () => setShowDropdown(!showDropdown);

  const toggleActSelection = (item) => {
    setSelectedAct((prev) =>
      prev.includes(item) ? prev?.filter((i) => i !== item) : [...prev, item]
    );
  };

  const toggleLocationSelection = (item) => {
    setSelectedLocation((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const sortReports = (reports, sortBy) => {
    const criticalityOrder = {
      High: 3,
      Medium: 2,
      Low: 1,
    };

    return [...reports].sort((a, b) => {
      switch (sortBy) {
        case "alphaAsc":
          return a.companyName.localeCompare(b.companyName);
        case "alphaDesc":
          return b.companyName.localeCompare(a.companyName);
        case "dueAsc":
          return new Date(a.dueDate || 0) - new Date(b.dueDate || 0);
        case "dueDesc":
          return new Date(b.dueDate || 0) - new Date(a.dueDate || 0);
        case "critLowHigh":
          return (
            (criticalityOrder[a.criticality] || 0) -
            (criticalityOrder[b.criticality] || 0)
          );
        case "critHighLow":
          return (
            (criticalityOrder[b.criticality] || 0) -
            (criticalityOrder[a.criticality] || 0)
          );
        default:
          return 0;
      }
    });
  };

  const handleQuickFilter = (type) => {
    const now = new Date();
    let start = new Date();
    let end = new Date();

    switch (type) {
      case "This Month":
        start = new Date(now.getFullYear(), now.getMonth(), 1);
        end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        break;
      case "Today":
        break;
      case "Yesterday":
        start.setDate(now.getDate() - 1);
        end.setDate(now.getDate() - 1);
        break;
      case "Last 7 days":
        start.setDate(now.getDate() - 6);
        break;
      case "Last 30 days":
        start.setDate(now.getDate() - 29);
        break;
      case "Manual":
        setActiveFilter("Manual");
        return;
      default:
        return;
    }

    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    setFilterDateWise({ startDate: start, endDate: end });
    setActiveFilter(type);
    setIsOpen(false); // Close dropdown when quick filter is selected

    // applyDateFilter({ startDate: start, endDate: end });
  };

  const applyDateFilter = () => {
    if (!filterDateWise.startDate || !filterDateWise.endDate) return;

    const dateFiltered = reports.filter((item) =>
      isLocalDateInRange(item.dueDate, filterDateWise.startDate, filterDateWise.endDate)
    );

    const finalFiltered = dateFiltered.filter((item) => {
      const companyMatch =
        selectedCompanies.length === 0 ||
        selectedCompanies.includes(item.companyName);
      const locationMatch =
        selectedLocation.length === 0 ||
        selectedLocation.includes(item.location);
      const subBranchMatch =
        selectedSubBranches.length === 0 ||
        selectedSubBranches.includes(item.sub_branch);

      return companyMatch && locationMatch && subBranchMatch;
    });

    setIsOpen(!isOpen);
    setFilteredReports(finalFiltered);
  };

  async function getCopmlianceById(id) {
    setLoading(true);
    setShowModal(true);

    try {
      const { data } = await requestApi(`/report/fetch/by-auditor/${id}`, {
        method: "get",
      });

      if (data) {
        setCompliance(data);

        // Populate form with existing data
        setFormData({
          complianceStatus: data.current_compliance_status || "",
          proofFile: null, // File input cannot be pre-populated for security reasons
          proofLink: data.proofs_link || "",
          comment: data.comment_of_officer || "",
          description: data.comp_description || "",
          reason: data.reason || "",
          criticality: data.criticality || "",
          period: data.period ? new Date(data.period).toISOString().split('T')[0] : "",
        });

        // Store existing proof file information for display
        const filePath = data.proof_file_url || data.proof_file_path || data.proof_file || null;
        const fileName = data.proof_file_name || (filePath ? filePath.split('/').pop() : null);
        setExistingProofFile({
          name: fileName,
          url: getCompleteFileUrl(filePath),
          originalPath: filePath,
        });

        // Clear any existing form errors
        setFormErrors({
          complianceStatus: "",
          proofFile: "",
          proofLink: "",
          comment: "",
          description: "",
          reason: "",
          criticality: "",
        });

        setShowModal(true);
      } else {
        toast.error("No data found.");
      }
    } catch (err) {
      console.log("error", err);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  }

  async function handleSubmit(e, id) {
    e.preventDefault();
    const isValid = validateForm(formData.complianceStatus);

    if (!id) {
      toast.info("Compliance ID is missing. Please try again.");
      return;
    }

    if (!isValid) {
      return;
    }

    const data = new FormData();

    data.append("current_compliance_status", formData.complianceStatus || "");
    data.append("comment_of_officer", formData.comment || "");
    data.append("proofs_link", formData.proofLink || "");
    data.append("compliance_description", formData.description || "");
    data.append("reason", formData.reason || "");
    data.append("criticality", formData.criticality || "");
    data.append("period", formData.period || "");

    if (formData.proofFile) {
      data.append("proof_file", formData.proofFile);
    }

    setLoading(true);

    try {
      await requestPutFormData(`/compliances/pending-update/${id}`, data);

      clearForm();
      fetchReports();
      setShowModal(false);
      toast.success("Compliance updated successfully!");
    } catch (err) {
      console.log("err", err);
      toast.error("Network error.");
    } finally {
      setLoading(false);
    }
  }

  const FORWARDABLE_STATUSES = [
    "Complied",
    "Not Complied",
    "Partial Complied",
    "Partially Complied",
    "Not Applicable",
  ];

  const isForwardableStatus = (status) => {
    const normalized = String(status || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");
    return FORWARDABLE_STATUSES.some(
      (s) => s.toLowerCase() === normalized
    );
  };

  // Show Forward only when the saved DB status is already allowed —
  // changing the status radio in the form must not reveal Forward.
  const savedComplianceStatus =
    compliance?.current_compliance_status || compliance?.currentstatus || "";

  const isAlreadyForwarded =
    compliance?.is_forward === 1 ||
    compliance?.is_forward === true ||
    String(compliance?.is_forward) === "1";

  const hasNextPeriodCompliance =
    compliance?.has_next_period_compliance === true ||
    compliance?.has_next_period_compliance === 1 ||
    Boolean(compliance?.next_period_compliance_id);

  const canForwardCompliance =
    isForwardableStatus(savedComplianceStatus) &&
    !isAlreadyForwarded &&
    hasNextPeriodCompliance;

  async function handleForward(id) {
    const isValid = validateForm(formData.complianceStatus);

    if (!id) {
      toast.info("Compliance ID is missing. Please try again.");
      return;
    }

    if (isAlreadyForwarded) {
      toast.info("This compliance has already been forwarded.");
      return;
    }

    if (!hasNextPeriodCompliance) {
      toast.info(
        "Forward is not allowed because no matching compliance exists for a future due date."
      );
      return;
    }

    if (!isForwardableStatus(savedComplianceStatus)) {
      toast.info(
        "Forward is allowed only when current status is already Complied, Not Complied, Partial Complied, or Not Applicable."
      );
      return;
    }

    if (!isValid) {
      return;
    }

    const data = new FormData();
    data.append("current_compliance_status", formData.complianceStatus || "");
    data.append("comment_of_officer", formData.comment || "");
    data.append("proofs_link", formData.proofLink || "");
    data.append("compliance_description", formData.description || "");
    data.append("reason", formData.reason || "");
    data.append("criticality", formData.criticality || "");
    data.append("period", formData.period || "");

    if (formData.proofFile) {
      data.append("proof_file", formData.proofFile);
    }

    setLoading(true);

    try {
      await requestFormData(`/compliances/forward/${id}`, data);

      clearForm();
      fetchReports();
      setShowModal(false);
      toast.success("Compliance forwarded successfully.");
    } catch (err) {
      console.log("forward err", err);
      toast.error(err?.message || "Failed to forward compliance.");
    } finally {
      setLoading(false);
    }
  }

  const resetAddComplianceForm = () => {
    setAddFormData({
      company_name: "",
      branch_id: "",
      location: "",
      legislation_name: "",
      sub_branch: "",
      compliance: "",
      compliance_description: "",
      provision: "",
      compliance_categorization: "",
      compliance_type: "",
      penalty_type: "",
      penalty_description: "",
      summary_of_observation: "",
      management_remark: "",
      proof_mandatory: "",
      criticality: "",
      auditor: "",
      approver: "",
      current_compliance_status: "",
      due_date: "",
      open_closed: "",
    });
    setAddFormErrors({});
  };

  const availableBranchesForAdd = useMemo(() => {
    const source = Array.isArray(reports) ? reports : [];
    const filtered = addFormData.company_name
      ? source.filter((r) => r.companyName === addFormData.company_name)
      : source;
    return [...new Set(filtered.map((r) => r.branchName).filter(Boolean))];
  }, [reports, addFormData.company_name]);

  const availableLocationsForAdd = useMemo(() => {
    const source = Array.isArray(reports) ? reports : [];
    const filtered = source.filter((r) => {
      const companyOk =
        !addFormData.company_name || r.companyName === addFormData.company_name;
      const branchOk =
        !addFormData.branch_id || r.branchName === addFormData.branch_id;
      return companyOk && branchOk;
    });
    return [...new Set(filtered.map((r) => r.location).filter(Boolean))];
  }, [reports, addFormData.company_name, addFormData.branch_id]);

  const availableActsForAdd = useMemo(() => {
    const source = Array.isArray(reports) ? reports : [];
    const filtered = source.filter((r) => {
      const companyOk =
        !addFormData.company_name || r.companyName === addFormData.company_name;
      const branchOk =
        !addFormData.branch_id || r.branchName === addFormData.branch_id;
      return companyOk && branchOk;
    });
    return [...new Set(filtered.map((r) => r.act).filter(Boolean))];
  }, [reports, addFormData.company_name, addFormData.branch_id]);

  const reportsMatchingAddSelection = useMemo(() => {
    const source = Array.isArray(reports) ? reports : [];
    return source.filter((r) => {
      const companyOk =
        !addFormData.company_name || r.companyName === addFormData.company_name;
      const branchOk =
        !addFormData.branch_id || r.branchName === addFormData.branch_id;
      return companyOk && branchOk;
    });
  }, [reports, addFormData.company_name, addFormData.branch_id]);

  const availableAuditorsForAdd = useMemo(() => {
    if (!addFormData.company_name || !addFormData.branch_id) return [];
    return [
      ...new Set(
        reportsMatchingAddSelection
          .map((r) => r.assignedAuditor)
          .filter(Boolean)
      ),
    ];
  }, [
    reportsMatchingAddSelection,
    addFormData.company_name,
    addFormData.branch_id,
  ]);

  const availableApproversForAdd = useMemo(() => {
    if (!addFormData.company_name || !addFormData.branch_id) return [];
    return [
      ...new Set(
        reportsMatchingAddSelection
          .map((r) => r.assignedApprover)
          .filter(Boolean)
      ),
    ];
  }, [
    reportsMatchingAddSelection,
    addFormData.company_name,
    addFormData.branch_id,
  ]);

  const handleAddFormChange = (e) => {
    const { name, value } = e.target;
    setAddFormData((prev) => {
      const next = { ...prev, [name]: value };
      if (name === "company_name") {
        next.branch_id = "";
        next.location = "";
        next.sub_branch = "";
        next.legislation_name = "";
        next.auditor = "";
        next.approver = "";
      }
      if (name === "branch_id") {
        next.location = "";
        next.sub_branch = "";
        next.legislation_name = "";
        next.auditor = "";
        next.approver = "";

        const source = Array.isArray(reports) ? reports : [];
        const matched = source.filter((r) => {
          const companyOk =
            !next.company_name || r.companyName === next.company_name;
          return companyOk && r.branchName === value;
        });
        const auditors = [
          ...new Set(matched.map((r) => r.assignedAuditor).filter(Boolean)),
        ];
        const approvers = [
          ...new Set(matched.map((r) => r.assignedApprover).filter(Boolean)),
        ];
        if (auditors.length === 1) next.auditor = auditors[0];
        if (approvers.length === 1) next.approver = approvers[0];
      }
      return next;
    });
    setAddFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateAddComplianceForm = () => {
    const errors = {};
    const requiredText = (value, label) => {
      if (!String(value || "").trim()) return `${label} is required.`;
      return "";
    };

    const companyErr = requiredText(addFormData.company_name, "Entity Name");
    if (companyErr) errors.company_name = companyErr;

    const branchErr = requiredText(addFormData.branch_id, "Branch ID");
    if (branchErr) errors.branch_id = branchErr;

    const locationErr = requiredText(addFormData.location, "Location");
    if (locationErr) errors.location = locationErr;

    const subBranchErr = requiredText(addFormData.sub_branch, "Sub Branch");
    if (subBranchErr) errors.sub_branch = subBranchErr;

    const legislationErr = requiredText(
      addFormData.legislation_name,
      "Legislation"
    );
    if (legislationErr) errors.legislation_name = legislationErr;

    const complianceErr = requiredText(addFormData.compliance, "Compliance");
    if (complianceErr) errors.compliance = complianceErr;

    const dueDateErr = requiredText(addFormData.due_date, "Due Date");
    if (dueDateErr) {
      errors.due_date = dueDateErr;
    } else {
      const due = new Date(addFormData.due_date);
      if (isNaN(due.getTime())) {
        errors.due_date = "Please enter a valid Due Date.";
      }
    }

    const descErr = requiredText(
      addFormData.compliance_description,
      "Compliance Description"
    );
    if (descErr) errors.compliance_description = descErr;

    const provisionErr = requiredText(addFormData.provision, "Provision");
    if (provisionErr) errors.provision = provisionErr;

    const categoryErr = requiredText(
      addFormData.compliance_categorization,
      "Compliance Categorization"
    );
    if (categoryErr) errors.compliance_categorization = categoryErr;

    const typeErr = requiredText(
      addFormData.compliance_type,
      "Compliance Type"
    );
    if (typeErr) errors.compliance_type = typeErr;

    const statusErr = requiredText(
      addFormData.current_compliance_status,
      "Current Compliance Status"
    );
    if (statusErr) {
      errors.current_compliance_status = statusErr;
    } else if (
      !statusOptions.includes(addFormData.current_compliance_status)
    ) {
      errors.current_compliance_status = "Please select a valid status.";
    }

    const penaltyTypeErr = requiredText(
      addFormData.penalty_type,
      "Penalty Type"
    );
    if (penaltyTypeErr) errors.penalty_type = penaltyTypeErr;

    const penaltyDescErr = requiredText(
      addFormData.penalty_description,
      "Penalty Description"
    );
    if (penaltyDescErr) errors.penalty_description = penaltyDescErr;

    const criticalityErr = requiredText(addFormData.criticality, "Critical");
    if (criticalityErr) {
      errors.criticality = criticalityErr;
    } else if (!["High", "Medium", "Low"].includes(addFormData.criticality)) {
      errors.criticality = "Please select High, Medium, or Low.";
    }

    const proofMandatoryErr = requiredText(
      addFormData.proof_mandatory,
      "Proof Mandatory"
    );
    if (proofMandatoryErr) {
      errors.proof_mandatory = proofMandatoryErr;
    } else if (!["Yes", "No"].includes(addFormData.proof_mandatory)) {
      errors.proof_mandatory = "Please select Yes or No.";
    }

    const auditorErr = requiredText(addFormData.auditor, "Auditor");
    if (auditorErr) {
      errors.auditor = auditorErr;
    } else if (
      availableAuditorsForAdd.length > 0 &&
      !availableAuditorsForAdd.includes(addFormData.auditor)
    ) {
      errors.auditor = "Please select an assigned Auditor for this report.";
    }

    const approverErr = requiredText(addFormData.approver, "Approver");
    if (approverErr) {
      errors.approver = approverErr;
    } else if (
      availableApproversForAdd.length > 0 &&
      !availableApproversForAdd.includes(addFormData.approver)
    ) {
      errors.approver = "Please select an assigned Approver for this report.";
    }

    if (
      addFormData.open_closed !== "0" &&
      addFormData.open_closed !== "1"
    ) {
      errors.open_closed = "Open / Closed is required.";
    }

    const summaryErr = requiredText(
      addFormData.summary_of_observation,
      "Summary of Observation"
    );
    if (summaryErr) errors.summary_of_observation = summaryErr;

    const remarkErr = requiredText(
      addFormData.management_remark,
      "Management Remarks"
    );
    if (remarkErr) errors.management_remark = remarkErr;

    setAddFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleAddComplianceSubmit = async (e) => {
    e.preventDefault();
    if (!validateAddComplianceForm()) return;

    setLoading(true);
    try {
      await requestApi("/compliances/create-by-officer", {
        method: "post",
        body: JSON.stringify(addFormData),
      });
      toast.success("Compliance created successfully!");
      setShowAddComplianceModal(false);
      resetAddComplianceForm();
      fetchReports();
    } catch (err) {
      console.log("add compliance err", err);
      toast.error(err?.message || "Failed to create compliance.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  const headerMap = {
    id: "ID",
    companyName: "Entity",
    branchName: "Branch Name",
    location: "Location",
    sub_branch: "Sub Branch",
    act: "Act",
    compd: "Compliance Description",
    //penalty_type: "Penalty Type",
    provision: "Provision",
    categorization: "Compliance Categorization",
    compliance_type: "Compliance Type",
    proof_mandatory: "Proof Mandatory",
    sub_branch: "Sub Branch",
    desc: "Detailed Description",
    dueDate: "Due Date",
    auditedDate: "Audited Date",
    summary_of_observation: "Summary of Observation",
    management_remark: "Management Remarks",
    additional_information: "Additional Information",
    knowledge_bank: "Knowledge Bank",
    currentstatus: "Current Status",
    //status: "Is Status Complete",
    score: "Compliance Score",
    criticality: "Criticality Level",
    penalty_type: "Penalty Type",
    penalty_description: "Penalty Description",
    assignedAuditor: "Assigned Auditor",
    complianceOfficer: "Compliance Officer",
    period: "Date of Compliance",
    created_at: "Created At",
  };

  // Format value for PDF
  const formatCell = (value) => {
    if (value === null || value === undefined) return "";
    if (typeof value === "boolean") return value ? "Yes" : "No";
    if (typeof value === "object") return JSON.stringify(value);
    return value;
  };

  const exportReport = (data, format, period, subBranches = []) => {
    const { startDate, endDate } = filterDateWise;

    // Filter data if a start date is defined
    let exportData = [...data];
    if (startDate && endDate) {
      exportData = exportData.filter((item) =>
        isLocalDateInRange(item.dueDate, startDate, endDate)
      );
    }

    if (subBranches.length > 0) {
      exportData = exportData.filter((item) =>
        subBranches.includes(item.sub_branch)
      );
    }

    const exportDataWithSerial = exportData.map((item, index) => ({
      ...item,
      id: index + 1,
    }));

    if (
      !Array.isArray(exportDataWithSerial) ||
      exportDataWithSerial.length === 0 ||
      !exportDataWithSerial[0]
    ) {
      toast.error("No data found for the selected period.");
      return;
    }

    const tableHeaders = Object.keys(headerMap);
    const displayHeaders = tableHeaders.map((key) => headerMap[key]);

    if (format === "excel") {
      const formattedData = exportDataWithSerial.map((item) => {
        const formatted = {};
        for (const key in headerMap) {
          let value = item[key];

          // Calculate score
          if (key === "score") {
            const status = (item["currentstatus"] || "").toLowerCase();
            if (status === "complied") value = 1;
            else if (status === "not complied") value = 0;
            else if (status === "partial complied") value = 0.5;
            else if (status === "not applicable") value = 0;
            else value = ""; // Skip "Not Updated" and others
          }

          // Format date fields
          if (
            ["dueDate", "period", "auditedDate", "created_at"].includes(key)
          ) {
            if (value && !isNaN(new Date(value).getTime())) {
              value = formatDate(value);
            } else {
              value = "NA";
            }
          }

          formatted[headerMap[key]] = value ?? "";
        }

        return formatted;
      });

      // Extract Company Name, Location, Date Range for top rows
      const companyNameList = [
        ...new Set(
          exportDataWithSerial
            .map((item) => item.companyName || item.company_name)
            .filter(Boolean)
        ),
      ];
      let companyNameText = "";
      if (companyNameList.length > 0) {
        companyNameText = companyNameList.join(", ");
      } else if (typeof selectedCompanies !== "undefined" && selectedCompanies && selectedCompanies.length > 0) {
        companyNameText = selectedCompanies.join(", ");
      } else {
        companyNameText = "Company Name";
      }

      const locationList = [
        ...new Set(
          exportDataWithSerial.map((item) => item.location).filter(Boolean)
        ),
      ];
      let locationText = "";
      if (locationList.length > 0) {
        locationText = locationList.join(", ");
      } else if (typeof selectedLocation !== "undefined" && selectedLocation && selectedLocation.length > 0) {
        locationText = Array.isArray(selectedLocation) ? selectedLocation.join(", ") : selectedLocation;
      } else {
        locationText = "All Locations";
      }

      let dateRangeText = "";
      if (startDate && endDate) {
        dateRangeText = `${formatDate(startDate)} to ${formatDate(endDate)}`;
      } else if (period) {
        dateRangeText = period;
      } else {
        dateRangeText = "All";
      }

      // Convert column index to Excel column letters (1 -> A, 26 -> Z, 27 -> AA, etc.)
      const getColumnLetter = (colIndex) => {
        let temp,
          letter = "";
        while (colIndex > 0) {
          temp = (colIndex - 1) % 26;
          letter = String.fromCharCode(65 + temp) + letter;
          colIndex = (colIndex - temp - 1) / 26;
        }
        return letter;
      };

      const totalCols = displayHeaders.length;
      const lastColLetter = getColumnLetter(totalCols);
      const totalRows = 4 + formattedData.length;

      // Start data table at origin "A4" to leave rows 1, 2, and 3 for metadata
      const worksheet = XLSX.utils.json_to_sheet(formattedData, {
        origin: "A4",
      });

      // Auto-adjust column widths
      const colWidths = displayHeaders.map((header) => ({
        wch: Math.max(header.length + 5, 18),
      }));
      worksheet["!cols"] = colWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

      const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

      XlsxPopulate.fromDataAsync(wbout)
        .then((wb) => {
          const sheet = wb.sheet(0);

          // 1. Row 1: Company Name (Left Aligned)
          const companyRange = sheet.range(`A1:${lastColLetter}1`);
          companyRange.merged(true);
          sheet.cell("A1").value(`Company Name: ${companyNameText}`);
          companyRange.style({
            bold: true,
            fontSize: 14,
            wrapText: true,
            horizontalAlignment: "left",
            verticalAlignment: "center",
            fill: "F2F2F2",
            border: true,
          });

          // 2. Row 2: Location (Left Aligned)
          const locationRange = sheet.range(`A2:${lastColLetter}2`);
          locationRange.merged(true);
          sheet.cell("A2").value(`Location: ${locationText}`);
          locationRange.style({
            bold: true,
            fontSize: 11,
            wrapText: true,
            horizontalAlignment: "left",
            verticalAlignment: "center",
            fill: "F2F2F2",
            border: true,
          });

          // 3. Row 3: Period (Left Aligned)
          const dateRange = sheet.range(`A3:${lastColLetter}3`);
          dateRange.merged(true);
          sheet.cell("A3").value(`Period: ${dateRangeText}`);
          dateRange.style({
            bold: true,
            fontSize: 11,
            wrapText: true,
            horizontalAlignment: "left",
            verticalAlignment: "center",
            fill: "F2F2F2",
            border: true,
          });

          // 4. Headings (Row 4): bold, larger text size, text wrapping, highlighted background, borders
          sheet.range(`A4:${lastColLetter}4`).style({
            bold: true,
            fontSize: 12,
            wrapText: true,
            horizontalAlignment: "center",
            verticalAlignment: "center",
            fill: "D9E1F2",
            border: true,
          });

          // 5. Data Contents (Row 5..totalRows): text wrapping, vertical alignment, borders
          if (totalRows >= 5) {
            sheet.range(`A5:${lastColLetter}${totalRows}`).style({
              wrapText: true,
              fontSize: 10,
              verticalAlignment: "center",
              border: true,
            });
          }

          return wb.outputAsync();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const a = document.createElement("a");
          a.href = url;
          a.download = `Report_${period}.xlsx`;
          a.click();
          window.URL.revokeObjectURL(url);
        });
    } else if (format === "pdf") {
      const newWindow = window.open();
      if (!newWindow) return;

      const tableRows = exportDataWithSerial.map((item) => {
        return `<tr>${tableHeaders
          .map((key) => {
            let value = item[key];

            // Apply score logic
            if (key === "score") {
              const status = (item["currentstatus"] || "").toLowerCase();
              if (status === "complied") value = 1;
              else if (status === "not complied") value = 0;
              else if (status === "partial complied") value = 0.5;
              else if (status === "not applicable") value = 0;
              else value = ""; // Not Updated or unrecognized
            }

            // Format date
            if (
              ["dueDate", "period", "auditedDate", "created_at"].includes(key)
            ) {
              if (value && !isNaN(new Date(value).getTime())) {
                value = formatDate(value);
              } else {
                value = "NA";
              }
            }

            return `<td>${formatCell(value)}</td>`;
          })
          .join("")}</tr>`;
      });

      const htmlContent = `
      <html>
        <head>
          <title>Report</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 16px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 10px;
              margin-top: 12px;
            }
            th, td {
              border: 1px solid #000;
              padding: 6px 10px;
              text-align: left;
              vertical-align: top;
            }
            th {
              background-color: #f0f0f0;
              font-weight: bold;
            }
            h2 {
              text-align: center;
              margin-bottom: 10px;
            }
              @media print {
  body {
    zoom: 50%; /* scale down for printing */
  }
}
          </style>
        </head>
        <body>
          <h2>Filtered Report - ${period}</h2>
          <table>
            <thead>
              <tr>${displayHeaders.map((h) => `<th>${h}</th>`).join("")}</tr>
            </thead>
            <tbody>${tableRows.join("")}</tbody>
          </table>
        </body>
      </html>
    `;

      newWindow.document.write(htmlContent);
      newWindow.document.close();
      newWindow.print();
    }
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    if (isNaN(date)) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // const formatCell = (val) => {
  //   if (val instanceof Date) return val.toLocaleDateString();
  //   if (typeof val === "string" && !isNaN(Date.parse(val))) {
  //     return new Date(val).toLocaleString();
  //   }
  //   return val;
  // };

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
      </div>
    );
  }
  <style>
    {`
  @keyframes blink {
    50% { opacity: 0; }
  }
  .blink {
    animation: blink 1s step-start infinite;
  }
`}
  </style>;
  return (

    <section className="bs-table lyt-section-new   p-5">
      <div className=" ">
        <div className="d-flex ">
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            {" "}
          </div>
        </div>
      </div>

      <div className=" ">
        <div className="d-flex justify-content-between mb-2">
          <div
            className="d-flex align-items-center justify-content-left p-3 bg-white rounded shadow-sm gap-3 number-box"

          >
            <div
              className="d-flex align-items-center justify-content-center rounded-circle bg-light"
              style={{ flexShrink: 0 }}
            >
              <svg
                width={64}
                height={65}
                viewBox="0 0 64 65"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  opacity="0.1"
                  y="0.5"
                  width={64}
                  height={64}
                  rx={32}
                  fill="#564AB1"
                />
                <path
                  d="M45.9116 43.7126V19.5H26.1042V23.5136H19.0884V43.7126H17V44.5284H48V43.7126L45.9116 43.7126ZM45.0958 20.2832V43.68H38.4063V38.002H33.6095V43.7126H26.8874V20.2831L45.0958 20.2832ZM37.5905 43.7126H34.3927V38.8179H37.5905V43.7126ZM19.9042 24.2968H26.1042V43.7126H19.9042V24.2968Z"
                  fill="#564AB1"
                />
                <path
                  d="M31.3903 22.0127H28.584V24.819H31.3903V22.0127ZM30.6071 24.0032H29.3998V22.7959H30.6071V24.0032Z"
                  fill="#564AB1"
                />
                <path
                  d="M35.404 22.0127H32.5977V24.819H35.404V22.0127ZM34.5882 24.0032H33.3809V22.7959H34.5882V24.0032Z"
                  fill="#564AB1"
                />
                <path
                  d="M39.3844 22.0127H36.5781V24.819H39.3844V22.0127ZM38.6012 24.0032H37.3939V22.7959H38.6012V24.0032Z"
                  fill="#564AB1"
                />
                <path
                  d="M43.3981 22.0127H40.5918V24.819H43.3981V22.0127ZM42.6151 24.0032H41.4078V22.7959L42.6151 22.7957V24.0032Z"
                  fill="#564AB1"
                />
                <path
                  d="M31.3903 25.9932H28.584V28.7995H31.3903V25.9932ZM30.6071 27.9837H29.3998V26.7764H30.6071V27.9837Z"
                  fill="#564AB1"
                />
                <path
                  d="M35.404 25.9932H32.5977V28.7995H35.404V25.9932ZM34.5882 27.9837H33.3809V26.7764H34.5882V27.9837Z"
                  fill="#564AB1"
                />
                <path
                  d="M39.3844 25.9932H36.5781V28.7995H39.3844V25.9932ZM38.6012 27.9837H37.3939V26.7764H38.6012V27.9837Z"
                  fill="#564AB1"
                />
                <path
                  d="M43.3981 25.9932H40.5918V28.7995H43.3981V25.9932ZM42.6151 27.9837H41.4078V26.7764L42.6151 26.7762V27.9837Z"
                  fill="#564AB1"
                />
                <path
                  d="M31.3903 30.0068H28.584V32.8132H31.3903V30.0068ZM30.6071 31.9974H29.3998V30.7901H30.6071V31.9974Z"
                  fill="#564AB1"
                />
                <path
                  d="M35.404 30.0068H32.5977V32.8132H35.404V30.0068ZM34.5882 31.9974H33.3809V30.7901H34.5882V31.9974Z"
                  fill="#564AB1"
                />
                <path
                  d="M39.3844 30.0068H36.5781V32.8132H39.3844V30.0068ZM38.6012 31.9974H37.3939V30.7901H38.6012V31.9974Z"
                  fill="#564AB1"
                />
                <path
                  d="M43.3981 30.0068H40.5918V32.8132H43.3981V30.0068ZM42.6151 31.9974H41.4078V30.7901H42.6151V31.9974Z"
                  fill="#564AB1"
                />
                <path
                  d="M31.3903 33.9883H28.584V36.7946H31.3903V33.9883ZM30.6071 36.0114H29.3998V34.8041H30.6071V36.0114Z"
                  fill="#564AB1"
                />
                <path
                  d="M35.404 33.9883H32.5977V36.7946H35.404V33.9883ZM34.5882 36.0114H33.3809V34.8041H34.5882V36.0114Z"
                  fill="#564AB1"
                />
                <path
                  d="M39.3844 33.9883H36.5781V36.7946H39.3844V33.9883ZM38.6012 36.0114H37.3939V34.8041H38.6012V36.0114Z"
                  fill="#564AB1"
                />
                <path
                  d="M43.3981 33.9883H40.5918V36.7946H43.3981V33.9883ZM42.6151 36.0114H41.4078V34.8041H42.6151V36.0114Z"
                  fill="#564AB1"
                />
                <path
                  d="M31.3903 38.0015H28.584V40.8078H31.3903V38.0015ZM30.6071 39.992H29.3998V38.7847H30.6071V39.992Z"
                  fill="#564AB1"
                />
                <path
                  d="M43.3981 38.0015H40.5918V40.8078H43.3981V38.0015ZM42.6151 39.992H41.4078V38.7847H42.6151V39.992Z"
                  fill="#564AB1"
                />
                <path
                  d="M21.6016 25.9932V28.7995H24.4079V25.9932H21.6016ZM23.5921 27.9837H22.3845V26.7764H23.5919L23.5921 27.9837Z"
                  fill="#564AB1"
                />
                <path
                  d="M21.6016 32.8132H24.4079V30.0068H21.6016V32.8132ZM22.3846 30.7901H23.5919L23.5921 31.9974H22.3846L22.3846 30.7901Z"
                  fill="#564AB1"
                />
                <path
                  d="M21.6016 36.7946H24.4079V33.9883H21.6016V36.7946ZM22.3846 34.8041H23.5919V36.0114H22.3846V34.8041Z"
                  fill="#564AB1"
                />
                <path
                  d="M21.6016 40.8078H24.4079V38.0015H21.6016V40.8078ZM22.3846 38.7847H23.5919V39.992H22.3846V38.7847Z"
                  fill="#564AB1"
                />
              </svg>
            </div>
            <div className="">
              <div className="fw-bold count  color1">
                {totals.totalCompany}
              </div>
              <div className="text-muted  fs-12">Total Company</div>
            </div>
          </div>

          <div
            className="d-flex align-items-center justify-content-left p-3 bg-white rounded shadow-sm gap-3 number-box"

          >
            <div
              className="d-flex align-items-center justify-content-center rounded-circle bg-light"
              style={{ flexShrink: 0 }}
            >
              <svg
                width={64}
                height={64}
                viewBox="0 0 34 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_491_1099)">
                  <path
                    d="M12.2626 26.5333L11.7645 27.3959C11.5813 27.7133 11.1748 27.8222 10.8574 27.6389C10.54 27.4557 10.4311 27.0493 10.6144 26.7318L11.1124 25.8692C11.2957 25.5518 11.7021 25.4429 12.0195 25.6262C12.337 25.8095 12.4459 26.2159 12.2626 26.5333ZM11.7645 6.60344C11.5813 6.28602 11.1748 6.17711 10.8574 6.36039C10.54 6.54367 10.4311 6.95008 10.6144 7.2675L11.1124 8.13012C11.2957 8.44754 11.7021 8.55645 12.0195 8.37316C12.337 8.18988 12.4459 7.78348 12.2626 7.46605L11.7645 6.60344ZM8.13078 11.1118L7.26816 10.6137C6.95074 10.4304 6.54434 10.5393 6.36105 10.8568C6.17777 11.1742 6.28668 11.5806 6.6041 11.7639L7.46672 12.2619C7.78414 12.4452 8.19055 12.3363 8.37383 12.0189C8.55711 11.7014 8.4482 11.295 8.13078 11.1118ZM7.03906 16.9993C7.03906 16.6328 6.74156 16.3353 6.375 16.3353H5.37891C5.01234 16.3353 4.71484 16.6328 4.71484 16.9993C4.71484 17.3659 5.01234 17.6634 5.37891 17.6634H6.375C6.74156 17.6634 7.03906 17.3659 7.03906 16.9993ZM7.46672 21.7368L6.6041 22.2348C6.28668 22.4181 6.17777 22.8245 6.36105 23.1419C6.54434 23.4593 6.95074 23.5682 7.26816 23.385L8.13078 22.8869C8.4482 22.7036 8.55711 22.2972 8.37383 21.9798C8.19055 21.6624 7.78414 21.5535 7.46672 21.7368ZM17 7.03906C17.3666 7.03906 17.6641 6.74156 17.6641 6.375V5.37891C17.6641 5.01234 17.3666 4.71484 17 4.71484C16.6334 4.71484 16.3359 5.01234 16.3359 5.37891V6.375C16.3359 6.74156 16.6334 7.03906 17 7.03906ZM17 26.9609C16.6334 26.9609 16.3359 27.2584 16.3359 27.625V28.6211C16.3359 28.9877 16.6334 29.2852 17 29.2852C17.3666 29.2852 17.6641 28.9877 17.6641 28.6211V27.625C17.6641 27.2584 17.3666 26.9609 17 26.9609ZM26.5333 12.2626L27.3959 11.7645C27.7133 11.5813 27.8222 11.1748 27.6389 10.8574C27.4557 10.54 27.0493 10.4311 26.7318 10.6144L25.8692 11.1124C25.5518 11.2957 25.4429 11.7021 25.6262 12.0195C25.8095 12.337 26.2159 12.4459 26.5333 12.2626ZM31.3438 17C31.3438 24.9216 24.9216 31.3438 17 31.3438C9.0784 31.3438 2.65625 24.9216 2.65625 17C2.65625 9.0784 9.0784 2.65625 17 2.65625C24.9216 2.65625 31.3438 9.0784 31.3438 17ZM30.0156 17C30.0156 9.81152 24.1885 3.98438 17 3.98438C9.81152 3.98438 3.98438 9.81152 3.98438 17C3.98438 24.1885 9.81152 30.0156 17 30.0156C24.1885 30.0156 30.0156 24.1885 30.0156 17ZM18.2179 18.9796L19.0161 21.9599C19.1111 22.3138 18.9005 22.6784 18.5466 22.7734C18.1927 22.8683 17.8281 22.6578 17.7331 22.3039L17.6634 22.0449V24.3054C17.6634 24.6719 17.3659 24.9694 16.9993 24.9694C16.6328 24.9694 16.3353 24.6719 16.3353 24.3054V19.2279C15.375 18.9424 14.6751 18.0532 14.6751 17.0007C14.6751 15.717 15.7157 14.6764 16.9993 14.6764C18.283 14.6764 19.3236 15.717 19.3236 17.0007C19.3236 17.8374 18.8813 18.5712 18.2172 18.9802L18.2179 18.9796ZM18.3281 17C18.3281 16.2662 17.7338 15.6719 17 15.6719C16.2662 15.6719 15.6719 16.2662 15.6719 17C15.6719 17.7338 16.2662 18.3281 17 18.3281C17.7338 18.3281 18.3281 17.7338 18.3281 17ZM28.6211 16.3359H27.625C27.2584 16.3359 26.9609 16.6334 26.9609 17C26.9609 17.3666 27.2584 17.6641 27.625 17.6641H28.6211C28.9877 17.6641 29.2852 17.3666 29.2852 17C29.2852 16.6334 28.9877 16.3359 28.6211 16.3359ZM34 17C34 26.3892 26.3892 34 17 34C7.61082 34 0 26.3892 0 17C0 7.61082 7.61082 0 17 0C26.3885 0 34 7.61082 34 17ZM32.6719 17C32.6719 8.34461 25.6554 1.32812 17 1.32812C8.34461 1.32812 1.32812 8.34461 1.32812 17C1.32812 25.6554 8.34461 32.6719 17 32.6719C25.6554 32.6719 32.6719 25.6554 32.6719 17ZM22.8876 25.8692C22.7043 25.5518 22.2979 25.4429 21.9805 25.6262C21.663 25.8095 21.5541 26.2159 21.7374 26.5333L22.2355 27.3959C22.4187 27.7133 22.8252 27.8222 23.1426 27.6389C23.46 27.4557 23.5689 27.0493 23.3856 26.7318L22.8876 25.8692ZM23.1426 6.36039C22.8252 6.17711 22.4187 6.28602 22.2355 6.60344L21.7374 7.46605C21.5541 7.78348 21.663 8.18988 21.9805 8.37316C22.2979 8.55645 22.7043 8.44754 22.8876 8.13012L23.3856 7.2675C23.5689 6.95008 23.46 6.54367 23.1426 6.36039ZM27.3959 22.2348L26.5333 21.7368C26.2159 21.5535 25.8095 21.6624 25.6262 21.9798C25.4429 22.2972 25.5518 22.7036 25.8692 22.8869L26.7318 23.385C27.0493 23.5682 27.4557 23.4593 27.6389 23.1419C27.8222 22.8245 27.7133 22.4181 27.3959 22.2348Z"
                    fill="#14BDF1"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_491_1099">
                    <rect width={64} height={64} fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div
              className=" "
              onClick={() => filterByDueType("overdue")}
              style={{ cursor: "pointer" }}
            >
              <div className="fw-bold color2 count ">
                {totals.overdueActions}
              </div>
              <div className="text-muted  fs-12">Overdue Actions</div>
            </div>
          </div>
          <div
            className="d-flex align-items-center justify-content-left p-3 bg-white rounded shadow-sm gap-3 number-box"

          >
            <div
              className="d-flex align-items-center justify-content-center rounded-circle bg-light"
              style={{ flexShrink: 0 }}
            >
              <svg
                width={65}
                height={65}
                viewBox="0 0 65 65"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  opacity="0.1"
                  x="0.599609"
                  y="0.5"
                  width={64}
                  height={64}
                  rx={32}
                  fill="#27B593"
                />
                <g clipPath="url(#clip0_489_989)">
                  <path
                    d="M33 50C28.4591 50 24.1901 48.2317 20.9791 45.0209C17.7683 41.8099 16 37.5409 16 33C16 28.4591 17.7683 24.1901 20.9791 20.9791C24.19 17.7682 28.4591 16 33 16C37.5409 16 41.8099 17.7683 45.0209 20.9791C48.2317 24.1901 50 28.4591 50 33C50 37.5409 48.2317 41.8099 45.0209 45.0209C41.8099 48.2317 37.5409 50 33 50ZM33 17.0625C24.2121 17.0625 17.0625 24.2121 17.0625 33C17.0625 41.7879 24.2121 48.9375 33 48.9375C41.7879 48.9375 48.9375 41.7879 48.9375 33C48.9375 24.2121 41.7879 17.0625 33 17.0625Z"
                    fill="#27B593"
                  />
                  <path
                    d="M33 47.875C29.0267 47.875 25.2913 46.3277 22.4818 43.5182C19.6723 40.7087 18.125 36.9733 18.125 33C18.125 29.0267 19.6723 25.2913 22.4818 22.4818C25.2913 19.6723 29.0267 18.125 33 18.125C36.9733 18.125 40.7087 19.6723 43.5182 22.4818C46.3277 25.2913 47.875 29.0267 47.875 33C47.875 36.9733 46.3277 40.7087 43.5182 43.5182C40.7087 46.3277 36.9733 47.875 33 47.875ZM33 19.1875C25.3838 19.1875 19.1875 25.3838 19.1875 33C19.1875 40.6162 25.3838 46.8125 33 46.8125C40.6162 46.8125 46.8125 40.6162 46.8125 33C46.8125 25.3838 40.6162 19.1875 33 19.1875Z"
                    fill="#27B593"
                  />
                  <path
                    d="M33.0003 38.8405C31.8145 38.8405 30.8415 37.9497 30.7373 36.7684L29.5641 24.5414C29.4789 23.5758 29.8041 22.6162 30.4559 21.9043C31.1077 21.1924 32.0351 20.7842 33.0003 20.7842C33.9655 20.7842 34.8929 21.1924 35.5447 21.9043C36.1965 22.6162 36.5217 23.5759 36.4369 24.5373L35.263 36.7725C35.1592 37.9497 34.1863 38.8405 33.0003 38.8405ZM33.0003 21.8467C32.3226 21.8467 31.6972 22.122 31.2396 22.6218C30.7819 23.1217 30.5626 23.7688 30.6222 24.4439L31.7953 36.6709C31.8512 37.3037 32.3691 37.7779 33.0003 37.7779C33.6317 37.7779 34.1495 37.3037 34.205 36.675L35.3789 24.4398C35.4381 23.7688 35.2188 23.1217 34.7611 22.6218C34.3034 22.122 33.6781 21.8467 33.0003 21.8467Z"
                    fill="#27B593"
                  />
                  <path
                    d="M33 45.2153C31.5353 45.2153 30.3438 44.0237 30.3438 42.5591C30.3438 41.0944 31.5353 39.9028 33 39.9028C34.4647 39.9028 35.6562 41.0944 35.6562 42.5591C35.6562 44.0237 34.4647 45.2153 33 45.2153ZM33 40.9653C32.1212 40.9653 31.4062 41.6803 31.4062 42.5591C31.4062 43.4378 32.1212 44.1528 33 44.1528C33.8788 44.1528 34.5938 43.4378 34.5938 42.5591C34.5938 41.6803 33.8788 40.9653 33 40.9653Z"
                    fill="#27B593"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_489_989">
                    <rect
                      width={34}
                      height={34}
                      fill="white"
                      transform="translate(16 16)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div
              className=" "
              onClick={() => filterByDueType("due")}
              style={{ cursor: "pointer" }}
            >
              <div className="fw-bold color3 count">
                {totals.dueActions}
              </div>
              <div className="text-muted  fs-12">Due Actions</div>
            </div>
          </div>

          <div
            className="d-flex align-items-center justify-content-left p-3 bg-white rounded shadow-sm gap-3 number-box"

          >
            <div
              className="d-flex align-items-center justify-content-center rounded-circle bg-light"
              style={{ flexShrink: 0 }}
            >
              <svg
                width={65}
                height={65}
                viewBox="0 0 65 65"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  opacity="0.1"
                  x="0.400391"
                  y="0.5"
                  width={64}
                  height={64}
                  rx={32}
                  fill="#F9C132"
                />
                <g clipPath="url(#clip0_489_996)">
                  <g clipPath="url(#clip1_489_996)">
                    <path
                      d="M49 45.9331H17V46.9998H49V45.9331Z"
                      fill="#F9C132"
                    />
                    <path
                      d="M19.1329 44.8669H24.4663C24.7608 44.8669 24.9996 44.6281 24.9996 44.3335V34.7335C24.9996 34.439 24.7608 34.2002 24.4663 34.2002H19.1329C18.8384 34.2002 18.5996 34.439 18.5996 34.7335V44.3335C18.5996 44.6281 18.8384 44.8669 19.1329 44.8669ZM19.6663 35.2669H23.9329V43.8002H19.6663V35.2669Z"
                      fill="#F9C132"
                    />
                    <path
                      d="M34.0665 44.8665H39.3999C39.6944 44.8665 39.9332 44.6277 39.9332 44.3331V28.3331C39.9332 28.0386 39.6944 27.7998 39.3999 27.7998H34.0665C33.772 27.7998 33.5332 28.0386 33.5332 28.3331V44.3331C33.5332 44.6277 33.772 44.8665 34.0665 44.8665ZM34.5999 28.8665H38.8665V43.7998H34.5999V28.8665Z"
                      fill="#F9C132"
                    />
                    <path
                      d="M26.5997 44.8666H31.9331C32.2276 44.8666 32.4664 44.6278 32.4664 44.3332V21.9332C32.4664 21.6387 32.2276 21.3999 31.9331 21.3999H26.5997C26.3052 21.3999 26.0664 21.6387 26.0664 21.9332V44.3332C26.0664 44.6278 26.3052 44.8666 26.5997 44.8666ZM27.1331 22.4666H31.3997V43.7999H27.1331V22.4666Z"
                      fill="#F9C132"
                    />
                    <path
                      d="M41.5333 44.8667H46.8667C47.1612 44.8667 47.4 44.6279 47.4 44.3333V15.5333C47.4 15.2388 47.1612 15 46.8667 15H41.5333C41.2388 15 41 15.2388 41 15.5333V44.3333C41 44.6279 41.2388 44.8667 41.5333 44.8667ZM42.0667 16.0667H46.3333V43.8H42.0667V16.0667Z"
                      fill="#F9C132"
                    />
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_489_996">
                    <rect
                      width={37}
                      height={32}
                      fill="white"
                      transform="translate(14.4004 15.5)"
                    />
                  </clipPath>
                  <clipPath id="clip1_489_996">
                    <rect
                      width={32}
                      height={32}
                      fill="white"
                      transform="translate(17 15)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className=" ">
              <div className="fw-bold color4 count">
                {totals.totalActions}
              </div>
              <div className="text-muted  fs-12">Total Actions</div>
            </div>
          </div>
          <div
            className="d-flex align-items-center justify-content-left p-3 bg-white rounded shadow-sm gap-3 number-box"

          >
            <div
              className="d-flex align-items-center justify-content-center rounded-circle bg-light"
              style={{ flexShrink: 0 }}
            >
              <svg
                width={65}
                height={65}
                viewBox="0 0 65 65"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  opacity="0.1"
                  x="0.199219"
                  y="0.5"
                  width={64}
                  height={64}
                  rx={32}
                  fill="#FF8C00"
                />
                <g clipPath="url(#clip0_489_1021)">
                  <path
                    d="M25.5143 14.754L23.3942 16.678V16.657C23.3942 15.5021 22.4546 14.5625 21.2997 14.5625H16.657C15.5021 14.5625 14.5625 15.5021 14.5625 16.657V21.2996C14.5625 22.4546 15.5021 23.3942 16.657 23.3942H21.2997C22.4546 23.3942 23.3942 22.4546 23.3942 21.2996V18.1972L26.2704 15.587C26.5004 15.3782 26.5177 15.0225 26.309 14.7924C26.1001 14.5624 25.7444 14.5451 25.5143 14.754ZM22.2692 21.2996C22.2692 21.8343 21.8342 22.2692 21.2996 22.2692H16.657C16.1224 22.2692 15.6875 21.8342 15.6875 21.2996V16.657C15.6875 16.1225 16.1225 15.6875 16.657 15.6875H21.2997C21.8343 15.6875 22.2692 16.1225 22.2692 16.657V17.6989L20.4363 19.3624L18.5611 17.4871C18.3414 17.2676 17.9853 17.2676 17.7657 17.4871C17.5459 17.7069 17.546 18.0629 17.7657 18.2827L20.0198 20.5368C20.1294 20.6464 20.2734 20.7016 20.4176 20.7016C20.5528 20.7016 20.6881 20.6532 20.7956 20.5556L22.2692 19.2182L22.2692 21.2996ZM25.5144 27.7756L23.3942 29.6997V29.6786C23.3942 28.5238 22.4547 27.5842 21.2997 27.5842H16.657C15.5021 27.5842 14.5625 28.5238 14.5625 29.6786V34.3213C14.5625 35.4762 15.5021 36.4158 16.657 36.4158H21.2997C22.4546 36.4158 23.3942 35.4762 23.3942 34.3213V31.2188L26.2704 28.6087C26.5004 28.3999 26.5177 28.0442 26.309 27.8142C26.1001 27.584 25.7444 27.5667 25.5144 27.7756ZM22.2692 34.3214C22.2692 34.856 21.8342 35.2908 21.2996 35.2908H16.657C16.1224 35.2908 15.6875 34.8559 15.6875 34.3214V29.6787C15.6875 29.1441 16.1225 28.7092 16.657 28.7092H21.2997C21.8343 28.7092 22.2692 29.1442 22.2692 29.6787V30.7207L20.4363 32.384L18.5611 30.5088C18.3414 30.2892 17.9853 30.2892 17.7657 30.5088C17.5459 30.7285 17.546 31.0847 17.7657 31.3043L20.0198 33.5585C20.1294 33.668 20.2734 33.7232 20.4176 33.7232C20.5528 33.7232 20.6881 33.6748 20.7956 33.5773L22.2692 32.2398L22.2692 34.3214ZM25.5143 40.7972L23.3942 42.7213V42.7003C23.3942 41.5453 22.4546 40.6058 21.2996 40.6058H16.657C15.5021 40.6058 14.5625 41.5454 14.5625 42.7004V47.343C14.5625 48.4979 15.5021 49.4375 16.657 49.4375H21.2997C22.4546 49.4375 23.3942 48.4979 23.3942 47.343V44.2405L26.2704 41.6303C26.5004 41.4215 26.5177 41.0658 26.309 40.8358C26.1001 40.6056 25.7444 40.5884 25.5143 40.7972ZM22.2692 47.343C22.2692 47.8776 21.8342 48.3125 21.2996 48.3125H16.657C16.1225 48.3125 15.6875 47.8775 15.6875 47.343V42.7004C15.6875 42.1657 16.1225 41.7308 16.657 41.7308H21.2997C21.8343 41.7308 22.2692 42.1658 22.2692 42.7004V43.7423L20.4363 45.4056L18.5611 43.5304C18.3414 43.3108 17.9853 43.3108 17.7657 43.5304C17.5459 43.7501 17.546 44.1062 17.7657 44.3259L20.0198 46.5801C20.1294 46.6896 20.2734 46.7448 20.4176 46.7448C20.5528 46.7448 20.6881 46.6964 20.7956 46.5988L22.2692 45.2614L22.2692 47.343ZM46.4095 19.6136C46.4095 19.9242 46.1576 20.1761 45.847 20.1761H30.9793C30.6687 20.1761 30.4168 19.9242 30.4168 19.6136C30.4168 19.303 30.6687 19.0511 30.9793 19.0511H45.847C46.1577 19.0511 46.4095 19.303 46.4095 19.6136ZM47.8543 16.1033H28.972C28.0991 16.1033 27.3888 16.8135 27.3888 17.6865V21.5407C27.3888 22.4137 28.0991 23.124 28.972 23.124H47.8543C48.7273 23.124 49.4375 22.4137 49.4375 21.5407V17.6865C49.4375 16.8135 48.7273 16.1033 47.8543 16.1033ZM48.3125 21.5407C48.3125 21.7934 48.107 21.999 47.8543 21.999H28.972C28.7194 21.999 28.5138 21.7934 28.5138 21.5407V17.6865C28.5138 17.4338 28.7194 17.2283 28.972 17.2283H47.8543C48.107 17.2283 48.3125 17.4338 48.3125 17.6865V21.5407ZM46.4095 32C46.4095 32.3106 46.1576 32.5625 45.847 32.5625H30.9793C30.6687 32.5625 30.4168 32.3106 30.4168 32C30.4168 31.6894 30.6687 31.4375 30.9793 31.4375H45.847C46.1577 31.4375 46.4095 31.6894 46.4095 32ZM47.8543 28.4896H28.972C28.0991 28.4896 27.3888 29.1999 27.3888 30.0729V33.9271C27.3888 34.8001 28.0991 35.5104 28.972 35.5104H47.8543C48.7273 35.5104 49.4375 34.8001 49.4375 33.9271V30.0729C49.4375 29.1999 48.7273 28.4896 47.8543 28.4896ZM48.3125 33.9271C48.3125 34.1798 48.107 34.3854 47.8543 34.3854H28.972C28.7194 34.3854 28.5138 34.1798 28.5138 33.9271V30.0729C28.5138 29.8202 28.7194 29.6146 28.972 29.6146H47.8543C48.107 29.6146 48.3125 29.8202 48.3125 30.0729V33.9271ZM46.4095 44.3864C46.4095 44.697 46.1576 44.9489 45.847 44.9489H30.9793C30.6687 44.9489 30.4168 44.697 30.4168 44.3864C30.4168 44.0757 30.6687 43.8239 30.9793 43.8239H45.847C46.1577 43.8239 46.4095 44.0757 46.4095 44.3864ZM47.8543 40.876H28.972C28.0991 40.876 27.3888 41.5863 27.3888 42.4593V46.3135C27.3888 47.1864 28.0991 47.8967 28.972 47.8967H47.8543C48.7273 47.8967 49.4375 47.1864 49.4375 46.3135V42.4593C49.4375 41.5863 48.7273 40.876 47.8543 40.876ZM48.3125 46.3135C48.3125 46.5662 48.107 46.7717 47.8543 46.7717H28.972C28.7194 46.7717 28.5138 46.5662 28.5138 46.3135V42.4593C28.5138 42.2066 28.7194 42.001 28.972 42.001H47.8543C48.107 42.001 48.3125 42.2066 48.3125 42.4593V46.3135Z"
                    fill="#FF8C00"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_489_1021">
                    <rect
                      width={36}
                      height={36}
                      fill="white"
                      transform="translate(14 14)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className=" ">
              <div className="fw-bold color5 count">
                {totals.totalScore}
              </div>
              <div className="text-muted  fs-12">Total Score</div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4">
        <div className="card">
          <div className="card-body p-0">
            <div className="table-responsive">
              <div className="p-4 typ-comman-he">
                <div className="mb-4">
                  <div className="d-flex  justify-content-between">
                    <div className="d-flex  w-100 justify-content-between ">
                      <div className="d-flex gap-4">
                        <Dropdown
                          label="Select Company Name"
                          options={companies}
                          selectedItems={selectedCompanies}
                          setSelectedItems={setSelectedCompanies}
                        />

                        <Dropdown
                          label="Sub Branch"
                          options={availableSubBranches}
                          selectedItems={selectedSubBranches}
                          setSelectedItems={setSelectedSubBranches}
                        />




                        <div className="dropdown">
                          <button
                            className="d-flex align-items-center gap-2"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{
                              border: "1px solid #E4E4E7",
                              backgroundColor: "#FFFFFF",
                              color: "#1F1F23",
                              borderRadius: "5px",
                              padding: "6px 14px",
                              fontSize: "12px",
                              fontWeight: "500",
                              boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                            }}
                          >
                            <span className="text-dark fs-12">Act</span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="black"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fillRule="evenodd"
                                d="M1.5 5.5a.5.5 0 0 1 .854-.354l5.646 5.646 5.646-5.646a.5.5 0 1 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1-.146-.354"
                              />
                            </svg>
                          </button>

                          <div
                            className="dropdown-menu p-2 shadow "
                            style={{ width: "350px" }}
                          >
                            <input
                              type="text"
                              className="form-control mb-2"
                              placeholder="Search"
                              value={actSearchName}
                              onChange={(e) => setActSearchName(e.target.value)}
                            />
                            <div
                              style={{
                                // maxWidth: "350px",
                                // overflowX: "auto",
                                maxHeight: "200px",
                                overflowY: "auto",
                                scrollbarHeight: "5px",
                                scrollbarWidth: "thin",
                              }}
                            >
                              <div className="list-group border-0">
                                {/* <label className="list-group-item text-muted border-bottom border-0 d-flex align-items-center" style={{ fontSize: "12px", minWidth: "600px" }}>
                            <input type="checkbox" className="form-check-input me-2" /> Select All
                          </label> */}
                                {[...new Set(reports.map((item) => item.act))]
                                  .filter((name) =>
                                    name
                                      .toLowerCase()
                                      .includes(actSearchName.toLowerCase())
                                  )
                                  .map((name, index) => (
                                    <label
                                      key={index}
                                      className="list-group-item text-muted border-bottom border-0 d-flex align-items-center"
                                      style={{ fontSize: "12px" }}
                                    >
                                      <input
                                        type="checkbox"
                                        className="form-check-input me-2 fs-12"
                                        checked={selectedAct.includes(name)}
                                        onChange={() =>
                                          toggleActSelection(name)
                                        }
                                        style={{
                                          width: "16px",
                                          height: "16px",
                                          flexShrink: 0,
                                          cursor: "pointer",
                                        }}
                                      />
                                      {name}
                                    </label>
                                  ))}
                              </div>
                            </div>
                          </div>
                        </div>

                        <Dropdown
                          label="Select Location"
                          options={locations}
                          selectedItems={selectedLocation}
                          setSelectedItems={setSelectedLocation}
                        />

                        <Dropdown
                          label="Select Status"
                          options={statusOptions}
                          selectedItems={selectedStatus}
                          setSelectedItems={setSelectedStatus}
                        />

                        <div className="position-relative d-inline-block" ref={dateDropdownRef}>
                          <button
                            aria-expanded={isOpen}
                            className="btn bg-white border border-secondary-subtle d-flex align-items-center gap-2 w-20"
                            type="button"
                            data-bs-toggle="dropdown"

                            onClick={() => setIsOpen(!isOpen)}
                          >
                            <img
                              src="https://cdn-icons-png.flaticon.com/512/747/747310.png"
                              alt="Calendar Icon"
                              width="16"
                              height="16"
                            />
                            <span className="fs-12">
                              {filterDateWise.startDate?.toLocaleDateString("en-GB")} -{" "}
                              {filterDateWise.endDate?.toLocaleDateString("en-GB")}
                            </span>
                          </button>

                          {isOpen && (
                            <div
                              className="position-absolute mt-2 bg-white border shadow p-3"
                              style={{
                                zIndex: 1000,
                                width: "718px",
                                maxWidth: "95vw",
                                right: 0,
                                overflow: "hidden",
                              }}
                            >
                              <div className="row">
                                <div className="col-md-3">
                                  <ul className="list-group fs-12">
                                    {[
                                      "This Month",
                                      "Today",
                                      "Yesterday",
                                      "Last 7 days",
                                      "Last 30 days",
                                      "Manual",
                                    ].map((label) => (
                                      <li
                                        key={label}
                                        className={`list-group-item ${activeFilter === label ? "bg-light rounded" : ""
                                          }`}
                                        style={{ border: "none", cursor: "pointer" }}
                                        onClick={() => handleQuickFilter(label)}
                                      >
                                        {label}
                                      </li>
                                    ))}
                                  </ul>
                                </div>

                                {activeFilter === "Manual" && (
                                <div className="col-md-9 border-start">
                                  <div className="row">
                                    <div className="col-md-6">
                                      <DatePicker
                                        selected={filterDateWise.startDate}
                                        onChange={(date) =>
                                          setFilterDateWise((prev) => ({
                                            ...prev,
                                            startDate: date ? startOfLocalDay(date) : date,
                                          }))
                                        }
                                        inline
                                      />
                                    </div>
                                    <div className="col-md-6">
                                      <DatePicker
                                        selected={filterDateWise.endDate}
                                        onChange={(date) =>
                                          setFilterDateWise((prev) => ({
                                            ...prev,
                                            endDate: date ? endOfLocalDay(date) : date,
                                          }))
                                        }
                                        inline
                                      />
                                    </div>
                                  </div>

                                  <div className="mt-3 d-flex justify-content-between align-items-center">
                                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                      <span
                                        style={{
                                          backgroundColor: "#343a40",
                                          color: "#fff",
                                          padding: "6px 12px",
                                          borderRadius: "6px",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {filterDateWise.startDate?.toLocaleDateString("en-GB")}
                                      </span>

                                      <span style={{ fontSize: "16px" }}>→</span>

                                      <span
                                        style={{
                                          backgroundColor: "#343a40",
                                          color: "#fff",
                                          padding: "6px 12px",
                                          borderRadius: "6px",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {filterDateWise.endDate?.toLocaleDateString("en-GB")}
                                      </span>
                                    </div>

                                    <button className="btn btn-dark fs-12" onClick={applyDateFilter}>
                                      Apply
                                    </button>
                                  </div>
                                </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>

                      </div>
                      <div className="d-flex gap-4">
                        <div className="">
                          <button
                            className="btn bg-white border border-secondary-subtle d-flex align-items-center justify-content-center p-2 shadow-sm fh"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              viewBox="0 0 16 16"
                            >
                              <path d="M3 3h10v1H3V3zm0 3h7v1H3V6zm0 3h4v1H3V9zm8 2h3v-3h1v3h3l-3.5 3.5L11 11z" />
                            </svg>
                          </button>

                          <ul
                            className="dropdown-menu shadow-sm"
                            style={{ minWidth: "180px", fontSize: "12px" }}
                          >
                            <li>
                              <span
                                onClick={() => setSortBy("alphaDesc")}
                                className="dropdown-item d-flex justify-content-between align-items-center fs-12"
                                style={{ cursor: "pointer" }}
                              >
                                Reverse Alphabetical{" "}
                                <small className="text-muted fs-12">Z–A</small>
                              </span>
                            </li>
                            <li>
                              <span
                                onClick={() => setSortBy("alphaAsc")}
                                className="dropdown-item d-flex justify-content-between align-items-center fs-12"
                                style={{ cursor: "pointer" }}
                              >
                                Alphabetical{" "}
                                <small className="text-muted fs-12">A–Z</small>
                              </span>
                            </li>
                            <li>
                              <span
                                onClick={() => setSortBy("dueAsc")}
                                className="dropdown-item d-flex justify-content-between align-items-center fs-12"
                                style={{ cursor: "pointer" }}
                              >
                                Due Date - Ascending{" "}
                                <small className="text-muted fs-12">
                                  Oldest
                                </small>
                              </span>
                            </li>
                            <li>
                              <span
                                onClick={() => setSortBy("dueDesc")}
                                className="dropdown-item d-flex justify-content-between align-items-center fs-12"
                                style={{ cursor: "pointer" }}
                              >
                                Due Date - Descending{" "}
                                <small className="text-muted fs-12">
                                  Newest
                                </small>
                              </span>
                            </li>
                            <li>
                              <span
                                onClick={() => setSortBy("critHighLow")}
                                className="dropdown-item d-flex justify-content-between align-items-center fs-12"
                                style={{ cursor: "pointer" }}
                              >
                                Criticality{" "}
                                <small className="text-danger fs-12">
                                  High–Low
                                </small>
                              </span>
                            </li>
                            <li>
                              <span
                                onClick={() => setSortBy("critLowHigh")}
                                className="dropdown-item d-flex justify-content-between align-items-center fs-12"
                                style={{ cursor: "pointer" }}
                              >
                                Criticality{" "}
                                <small className="text-success fs-12">
                                  Low–High
                                </small>
                              </span>
                            </li>
                          </ul>
                        </div>



                        <div
                          className="dropdown position-relative"
                          ref={dropdownRef1}
                        >
                          <button
                            className="btn d-flex align-items-center justify-content-center p-2 shadow-sm fh"
                            type="button"
                            style={{
                              backgroundColor: "#ffffff",
                              border: "1px solid #dcdcdc",
                              borderRadius: "4px",
                            }}
                            onClick={() => setIsOpen3(!isOpen3)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 16 16"
                            >
                              <path d="M4 3h2v10H4V3zm3 0h2v10H7V3zm3 0h2v10h-2V3z" />
                            </svg>
                          </button>

                          {isOpen3 && (
                            <div
                              className="dropdown-menu show p-2 shadow-sm bg-white border border-secondary-subtle"
                              style={{
                                width: "250px",
                                borderRadius: "5px",
                                fontSize: "12px",
                                right: -120,
                              }}
                            >
                              <div className="fw-bold text-muted p-2 bg-light fs-12">
                                Default View
                              </div>

                              <div className="d-flex justify-content-between py-1 border-bottom bg-light">
                                <span className="fw-bold fs-12">Hidden</span>
                                <span
                                  className="text-primary fs-12"
                                  style={{ cursor: "pointer" }}
                                  onClick={handleShowAllColumns}
                                >
                                  Show all
                                </span>
                              </div>

                              <ul className="list-unstyled px-2 fs-12">
                                {[
                                  { key: "srNo", label: "Sr No" },
                                  { key: "entity", label: "Entity" },
                                  { key: "branchId", label: "Branch ID" },
                                  { key: "acts", label: "Acts" },
                                  {
                                    key: "compDesc",
                                    label: "Compliance Description",
                                  },
                                  {
                                    key: "dateOfCompliance",
                                    label: "Date of Compliance",
                                  },
                                  { key: "dueDate", label: "Due Date" },
                                  { key: "auditor", label: "Auditor" },
                                  { key: "action", label: "Action" },
                                ].map((col) => (
                                  <li
                                    key={col.key}
                                    className="d-flex align-items-center py-1"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => toggleColumn(col.key)}
                                  >
                                    <span className="me-2 fs-12">⋮⋮</span>
                                    {col.label}
                                    <span className="ms-auto">
                                      {visibleColumns[col.key] ? "👁️" : "🙈"}
                                    </span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>

                        {/* <button
                          type="button"
                          className="btn btn-dark d-flex align-items-center gap-2 fh"
                          onClick={() => {
                            resetAddComplianceForm();
                            setShowAddComplianceModal(true);
                          }}
                          style={{
                            padding: "5px 12px",
                            fontSize: "12px",
                            fontWeight: 500,
                          }}
                        >
                          + Add Compliance
                        </button> */}

                        <div className="dropdown" ref={dropdownRef2}>
                          <button
                            className="btn btn-outline-dark d-flex align-items-center gap-2 fh"
                            onClick={toggleDropdown1}
                            style={{
                              border: "1px solid #ddd",
                              padding: "5px 10px",
                            }}
                          >
                            <i className="bi bi-file-earmark-arrow-down"></i>
                            Export
                          </button>

                          {showDropdown1 && (
                            <div
                              className="card shadow-sm position-absolute mt-2 end-0"
                              style={{
                                width: "200px",
                                zIndex: 9999,
                                transform: "translateX(10px)",
                              }}
                            >
                              <div>
                                <label className="bg-light py-1 px-2 w-100 fs-12">
                                  Format
                                </label>

                                <div className="btn-group w-100 mt-2 px-2">
                                  {formats.map((f) => (
                                    <button
                                      key={f.value}
                                      className={`btn ${format === f.value ? "btn-dark" : "btn-outline-dark"
                                        }`}
                                      onClick={() => setFormat(f.value)}
                                    >
                                      <i className={`bi ${f.icon}`}></i> {f.label}
                                    </button>
                                  ))}
                                </div>
                              </div>

                              <div className="d-flex justify-content-end">
                                <button
                                  className="btn btn-dark w-50 mt-3 mb-2 mx-2"
                                  onClick={() => {
                                    exportReport(
                                      filteredReports,
                                      format,
                                      period,
                                      selectedSubBranches
                                    );
                                    setShowDropdown(false); // ✅ close on export click
                                  }}
                                >
                                  Export
                                </button>
                              </div>
                            </div>
                          )}
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-scroll">
                  <table className="table table-hover align-middle mt-0 rounded vertical-border">
                    <thead className=" bg-light fs-12">
                      <tr>

                        {visibleColumns.srNo && <th>Sr No</th>}
                        {visibleColumns.entity && <th>Entity</th>}
                        {visibleColumns.branchId && <th>Branch ID</th>}
                        {visibleColumns.acts && <th>Acts</th>}
                        {visibleColumns.compDesc && (
                          <th>Compliance Description</th>
                        )}
                        {visibleColumns.dateOfCompliance && (
                          <th>Date of Compliance</th>
                        )}
                        {visibleColumns.dueDate && <th>Due Date</th>}
                        {visibleColumns.auditor && <th>Auditor</th>}
                        {visibleColumns.action && <th>Action</th>}
                      </tr>
                    </thead>
                    <tbody className="fs-12">
                      {Array.isArray(currentItems) && currentItems.length > 0 ? (
                        currentItems.map((key, i) => {
                          const srNumber = indexOfFirstItem + i + 1;
                          return (
                            <tr key={i}>
                              {visibleColumns.srNo && <td>{srNumber}</td>}
                              {visibleColumns.entity && (
                                <td>{key?.companyName || "NA"}</td>
                              )}
                              {visibleColumns.branchId && (
                                <td>
                                  <span style={{ color: "#0d6efd" }}>
                                    {key?.branchName || "NA"}
                                  </span>
                                </td>
                              )}
                              {visibleColumns.acts && <td>{key?.act || "NA"}</td>}
                              {visibleColumns.compDesc && (
                                <td>
                                  {key?.compd ?? "NA"}{" "}
                                  <button
                                    onClick={() => {
                                      setComplianceData(key);
                                      setShowModall(true);
                                    }}
                                    style={{
                                      background: "none",
                                      border: "none",
                                      padding: 0,
                                      marginLeft: "5px",
                                      cursor: "pointer",
                                      color: "#0d6efd",
                                    }}
                                    title="View Compliance"
                                  >
                                    <VisibilityIcon fontSize="small" />

                                  </button>
                                </td>
                              )}
                              {visibleColumns.dateOfCompliance && (
                                <td>
                                  {key?.period
                                    ? new Date(key.period)
                                      .toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                      })
                                      .replace(/ (\w{3}) /, " $1, ")
                                    : "NA"}
                                </td>
                              )}
                              {visibleColumns.dueDate && (
                                <td>
                                  <style>
                                    {`
                    @keyframes blink {
                      50% { opacity: 0; }
                    }
                    .blink {
                      animation: blink 2s step-start infinite;
                      font-weight: bold;
                    }
                    .text-green-600 {
                      color: #16a34a;
                    }
                    .text-red-600 {
                      color: #dc2626;
                    }
                  `}
                                  </style>
                                  {key?.dueDate
                                    ? (() => {
                                      const dueDate = new Date(key.dueDate);
                                      const today = new Date();
                                      const diffTime = dueDate - today;
                                      let diffDays = Math.ceil(
                                        diffTime / (1000 * 60 * 60 * 24)
                                      );
                                      if (diffDays < 0) diffDays = 0;

                                      const formattedDate = dueDate
                                        .toLocaleDateString("en-GB", {
                                          day: "2-digit",
                                          month: "short",
                                          year: "numeric",
                                        })
                                        .replace(/ (\w{3}) /, " $1, ");

                                      let blinkClass = "blink ";
                                      blinkClass +=
                                        diffDays > 0
                                          ? "text-green-600"
                                          : "text-red-600";

                                      return (
                                        <span>
                                          {formattedDate}{" "}
                                          {key.currentstatus !== "Complied" && (
                                            <span className={blinkClass}>
                                              ({diffDays} days to go)
                                            </span>
                                          )}
                                        </span>
                                      );
                                    })()
                                    : "NA"}
                                </td>
                              )}
                              {visibleColumns.auditor && (
                                <td>{key?.assignedAuditor || "NA"}</td>
                              )}
                              {visibleColumns.action && (
                                <td>
                                  {[
                                    "Complied",
                                    "Not Applicable",
                                    "Partial Complied",
                                    "Not Complied",
                                  ].includes(key?.currentstatus) ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          backgroundColor:
                                            key.currentstatus === "Complied"
                                              ? "#d1fae5"
                                              : key.currentstatus ===
                                                "Partial Complied"
                                                ? "#fef9c3"
                                                : key.currentstatus ===
                                                  "Not Complied"
                                                  ? "#fee2e2"
                                                  : "#f3f4f6",
                                          color:
                                            key.currentstatus === "Complied"
                                              ? "#065f46"
                                              : key.currentstatus ===
                                                "Partial Complied"
                                                ? "#92400e"
                                                : key.currentstatus ===
                                                  "Not Complied"
                                                  ? "#991b1b"
                                                  : "#4b5563",
                                          border:
                                            key.currentstatus === "Complied"
                                              ? "1px solid #10b981"
                                              : key.currentstatus ===
                                                "Partial Complied"
                                                ? "1px solid #facc15"
                                                : key.currentstatus ===
                                                  "Not Complied"
                                                  ? "1px solid #ef4444"
                                                  : "1px solid #9ca3af",
                                          borderRadius: "4px",
                                          padding: "3px 10px",
                                          fontSize: "12px",
                                          fontWeight: "500",
                                        }}
                                      >
                                        <span
                                          style={{
                                            display: "inline-block",
                                            width: "8px",
                                            height: "8px",
                                            borderRadius: "50%",
                                            backgroundColor:
                                              key.currentstatus === "Complied"
                                                ? "#10b981"
                                                : key.currentstatus ===
                                                  "Partial Complied"
                                                  ? "#facc15"
                                                  : key.currentstatus ===
                                                    "Not Complied"
                                                    ? "#ef4444"
                                                    : "#9ca3af",
                                            marginRight: "8px",
                                          }}
                                        ></span>
                                        {key?.currentstatus}
                                      </div>

                                      <a
                                        onClick={() =>
                                          getCopmlianceById(Number(key.id))
                                        }
                                        style={{
                                          color: "#0d6efd",
                                          cursor: "pointer",
                                          fontSize: "16px",
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          className="bi bi-pencil"
                                          viewBox="0 0 16 16"
                                        >
                                          <path
                                            d="M12.146.146a.5.5 0 0 1 .708 0l3 
             3a.5.5 0 0 1 0 .708l-10 10a.5.5 
             0 0 1-.168.11l-5 2a.5.5 0 0 
             1-.65-.65l2-5a.5.5 0 0 
             1 .11-.168l10-10zM11.207 
             2L13 3.793 14.793 2 13 
             .207 11.207 2zM12 4L10 2 
             3 9v2h2l7-7z"
                                          />
                                        </svg>
                                      </a>
                                    </div>
                                  ) : (
                                    <a
                                      onClick={() =>
                                        getCopmlianceById(Number(key.id))
                                      }
                                      style={{
                                        color: "#0d6efd",
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                        fontWeight: "500",
                                        fontSize: "12px",
                                      }}
                                    >
                                      Pending Update
                                    </a>
                                  )}
                                </td>
                              )}
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            colSpan={visibleColumnCount || 1}
                            style={{
                              textAlign: "center",
                              padding: "12px",
                              color: "#6c757d",
                            }}
                          >
                            No records found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                </div>
              </div>
              {showModall && complianceData && (
                <div
                  className="modal fade show d-block"
                  tabIndex="-1"
                  style={{ background: "rgba(0,0,0,0.5)" }}
                >
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Compliance Details</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowModall(false)}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <p>
                          <strong>Description:</strong>{" "}
                          {complianceData.desc || "NA"}
                        </p>
                        <p>
                          <strong>Penalty Type:</strong>{" "}
                          {complianceData.penalty_type || "NA"}
                        </p>
                        <p>
                          <strong>Penalty:</strong>{" "}
                          {complianceData.penalty_description || "NA"}
                        </p>
                      </div>
                      <div className="modal-footer">
                        <button
                          className="btn btn-secondary"
                          onClick={() => setShowModall(false)}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {(showModal || loading) && (
                <div
                  className="modal fade show d-block"
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                  }}
                >
                  <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                    style={{ maxWidth: "800px", width: "100%" }}
                  >
                    <div
                      className="modal-content p-3"
                      style={{ borderRadius: "12px" }}
                    >
                      <div className="d-flex justify-content-between align-items-center ">
                        <h5 className="modal-title"></h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={(e) => {
                            e.preventDefault();
                            setShowModal(false);
                            clearForm();
                          }}
                        />
                      </div>
                      <div>
                        <h4>Compliance Action</h4>
                        <div>
                          {" "}
                          <p
                            className="text-muted"
                            style={{ fontSize: "12px" }}
                          >
                            {" "}
                            <label style={{ fontSize: "12px" }}>
                              {" "}
                              Compliance Description:{" "}
                            </label>{" "}
                            {compliance?.compliance || "NA"}
                          </p>
                        </div>

                        <div className="d-flex gap-4">
                          <p
                            className="text-muted "
                            style={{ fontSize: "12px" }}
                          >
                            <label style={{ fontSize: "15px" }}>
                              Legislation:
                            </label>{" "}
                            {compliance?.legislation.legislation_name || "NA"}
                          </p>
                        </div>

                        <form onSubmit={(e) => handleSubmit(e, compliance?.id)}>
                          <div className="d-flex   ">
                            {/* Select Status */}
                            <div className="mb-2">
                              <label className="form-label d-block mb-2 fs-12">
                                Select Status
                              </label>
                              {[
                                "Complied",
                                "Partial Complied",
                                "Not Applicable",
                                "Not Complied",
                              ].map((status, i) => {
                                const colorClass =
                                  status === "Complied"
                                    ? "text-success"
                                    : status === "Partial Complied"
                                      ? "text-warning"
                                      : status === "Not Applicable"
                                        ? "text-secondary"
                                        : "text-danger";
                                return (
                                  <Fragment key={i}>
                                    <div className="form-check form-check-inline">
                                      <input
                                        className={`form-check-input border-${colorClass.split("-")[1]
                                          }`}
                                        type="radio"
                                        name="complianceStatus"
                                        value={status}
                                        checked={
                                          formData.complianceStatus === status
                                        }
                                        onChange={handleChange}
                                        id={`status-${i}`}
                                      />
                                      <label
                                        className={`form-check-label ${colorClass}`}
                                        htmlFor={`status-${i}`}
                                        style={{ fontWeight: 500 }}
                                      >
                                        {status}
                                      </label>
                                    </div>
                                  </Fragment>
                                );
                              })}
                              {formErrors.complianceStatus && (
                                <p
                                  className="text-danger"
                                  style={{ fontSize: "12px" }}
                                >
                                  {formErrors.complianceStatus}
                                </p>
                              )}
                            </div>

                            {/* Calendar Input */}
                            <div className="mb-2" style={{ width: "150px" }}>
                              <label className="form-label mb-2">Period</label>
                              <div className="input-group">
                                <input
                                  type="date"
                                  className="form-control"
                                  style={{
                                    fontSize: "12px",
                                    padding: "6px 10px",
                                    borderRadius: "5px",
                                  }}
                                  value={formData.period}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      period: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                          </div>

                          <div className="d-flex gap-3">
                            <div className="mb-3 ">
                              <label
                                htmlFor="proofFile"
                                className="form-label fs-12"
                              >
                                Upload Proof{" "}
                                {isProofMandatory && (
                                  <span className="text-danger">*</span>
                                )}
                              </label>

                              {/* Show existing proof file if available */}
                              {existingProofFile && existingProofFile.name && (
                                <div className="mb-2 p-2 bg-light rounded border" style={{ fontSize: "11px" }}>
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center gap-1">
                                      {/* File Icon */}
                                      <div className="d-flex align-items-center justify-content-center bg-white rounded border"
                                        style={{ width: "20px", height: "20px" }}>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="10"
                                          height="10"
                                          fill="#6c757d"
                                          className="bi bi-file-earmark"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M8 4a.5.5 0 0 1 .5.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5A.5.5 0 0 1 8 4z" />
                                          <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
                                        </svg>
                                      </div>

                                      <div>
                                        <span className="text-muted fw-medium" style={{ fontSize: "10px" }}>Current:</span>
                                        <br />
                                        {existingProofFile.url ? (
                                          <a
                                            href={existingProofFile.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-primary text-decoration-none"
                                            style={{ fontSize: "10px" }}
                                            title={existingProofFile.name}
                                          >
                                            {existingProofFile.name.length > 25
                                              ? existingProofFile.name.substring(0, 25) + '...'
                                              : existingProofFile.name}
                                          </a>
                                        ) : (
                                          <span className="text-muted" style={{ fontSize: "10px" }}>
                                            {existingProofFile.name.length > 25
                                              ? existingProofFile.name.substring(0, 25) + '...'
                                              : existingProofFile.name}
                                          </span>
                                        )}
                                      </div>
                                    </div>

                                    {/* Download Button */}
                                    {existingProofFile.url && (
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-outline-primary d-flex align-items-center"
                                        style={{ fontSize: "9px", padding: "2px 6px", height: "20px" }}
                                        onClick={() => {
                                          const link = document.createElement('a');
                                          link.href = existingProofFile.url;
                                          link.download = existingProofFile.name || 'proof-file';
                                          link.target = '_blank';
                                          link.rel = 'noopener noreferrer';
                                          document.body.appendChild(link);
                                          link.click();
                                          document.body.removeChild(link);
                                        }}
                                        title="Download file"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="8"
                                          height="8"
                                          fill="currentColor"
                                          className="bi bi-download"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                          <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                        </svg>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              )}

                              <input
                                type="file"
                                name="proofFile"
                                className="form-control"
                                id="proofFile"
                                onChange={handleChange}
                              />
                              {isProofMandatory && formErrors.proofFile && (
                                <p
                                  className="text-danger"
                                  style={{ fontSize: "12px" }}
                                >
                                  {formErrors.proofFile}
                                </p>
                              )}
                            </div>

                            <div className="mb-3 flex-fill">
                              <label
                                htmlFor="proofLink"
                                className="form-label fs-12"
                              >
                                Upload Proof Link
                              </label>
                              <input
                                type="text"
                                name="proofLink"
                                value={formData.proofLink}
                                onChange={handleChange}
                                className="form-control"
                                id="proofLink"
                                placeholder="Enter here"
                              />
                            </div>
                          </div>

                          {formData.complianceStatus === "Complied" && (
                            <>
                              <div className="mb-3">
                                <label
                                  htmlFor="comment"
                                  className="form-label fs-12"
                                >
                                  Comment <span className="text-danger">*</span>
                                </label>
                                <textarea
                                  name="comment"
                                  value={formData.comment}
                                  onChange={handleChange}
                                  className="form-control"
                                  id="comment"
                                  rows="1"
                                  placeholder="Enter here"
                                ></textarea>

                                {formErrors.comment && (
                                  <p
                                    className="text-danger"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {formErrors.comment}
                                  </p>
                                )}
                              </div>
                              <div className="mb-3">
                                <label
                                  htmlFor="description"
                                  className="form-label fs-12"
                                >
                                  Description{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <textarea
                                  name="description"
                                  value={formData.description}
                                  onChange={handleChange}
                                  className="form-control"
                                  id="description"
                                  rows="1"
                                  placeholder="Enter here"
                                />

                                {formErrors.description && (
                                  <p
                                    className="text-danger"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {formErrors.description}
                                  </p>
                                )}
                              </div>
                            </>
                          )}

                          {formData.complianceStatus === "Partial Complied" && (
                            <>
                              <div className="mb-3">
                                <label
                                  htmlFor="reason"
                                  className="form-label fs-12"
                                >
                                  Reason <span className="text-danger">*</span>
                                </label>
                                <textarea
                                  name="reason"
                                  value={formData.reason}
                                  onChange={handleChange}
                                  className="form-control"
                                  id="reason"
                                  rows="3"
                                  placeholder="Enter here"
                                />

                                {formErrors.reason && (
                                  <p
                                    className="text-danger"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {formErrors.reason}
                                  </p>
                                )}
                              </div>
                              <div className="mb-3">
                                <label
                                  htmlFor="comment"
                                  className="form-label fs-12"
                                >
                                  Comment <span className="text-danger">*</span>
                                </label>
                                <textarea
                                  name="comment"
                                  value={formData.comment}
                                  onChange={handleChange}
                                  className="form-control"
                                  id="comment"
                                  rows="3"
                                  placeholder="Enter here"
                                />

                                {formErrors.comment && (
                                  <p
                                    className="text-danger"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {formErrors.comment}
                                  </p>
                                )}
                              </div>
                            </>
                          )}

                          {formData.complianceStatus === "Not Applicable" && (
                            <div className="">
                              <label
                                htmlFor="description"
                                className="form-label fs-12"
                              >
                                Description{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <textarea
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                className="form-control"
                                id="description"
                                rows="3"
                                placeholder="Enter here"
                              />

                              {formErrors.description && (
                                <p
                                  className="text-danger"
                                  style={{ fontSize: "12px" }}
                                >
                                  {formErrors.description}
                                </p>
                              )}
                            </div>
                          )}

                          {formData.complianceStatus === "Not Complied" && (
                            <>
                              <div className="mb-3">
                                <label
                                  htmlFor="criticality"
                                  className="form-label fs-12"
                                >
                                  Criticality{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  name="criticality"
                                  value={formData.criticality}
                                  onChange={handleChange}
                                  className="form-select"
                                  id="criticality"
                                >
                                  <option value="" className="fs-12">
                                    Select...
                                  </option>
                                  <option value="High" className="fs-12">
                                    High
                                  </option>
                                  <option value="Medium" className="fs-12">
                                    Medium
                                  </option>
                                  <option value="Low" className="fs-12">
                                    Low
                                  </option>
                                </select>

                                {formErrors.criticality && (
                                  <p
                                    className="text-danger"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {formErrors.criticality}
                                  </p>
                                )}
                              </div>
                              <div className="mb-3">
                                <label
                                  htmlFor="reason"
                                  className="form-label fs-12"
                                >
                                  Reason <span className="text-danger">*</span>
                                </label>
                                <textarea
                                  name="reason"
                                  value={formData.reason}
                                  onChange={handleChange}
                                  className="form-control"
                                  id="reason"
                                  rows="3"
                                  placeholder="Enter here"
                                />

                                {formErrors.reason && (
                                  <p
                                    className="text-danger"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {formErrors.reason}
                                  </p>
                                )}
                              </div>
                            </>
                          )}

                          <div className="d-flex justify-content-end gap-2">
                            {canForwardCompliance && (
                              <button
                                type="button"
                                className="btn btn-outline-dark px-4 fs-12"
                                onClick={() => handleForward(compliance?.id)}
                                disabled={loading}
                              >
                                Forward
                              </button>
                            )}
                            <button
                              type="submit"
                              className="btn btn-dark px-4 fs-12"
                              disabled={loading}
                            >
                              Submit
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {showAddComplianceModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            role="document"
            style={{ maxWidth: "900px", width: "100%" }}
          >
            <div
              className="modal-content p-3"
              style={{
                borderRadius: "12px",
                maxHeight: "85vh",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="mb-0">Add Compliance</h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowAddComplianceModal(false);
                    resetAddComplianceForm();
                  }}
                />
              </div>

              <form
                onSubmit={handleAddComplianceSubmit}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minHeight: 0,
                  flex: 1,
                }}
              >
                <div
                  className="row g-3 pe-1"
                  style={{
                    overflowY: "auto",
                    maxHeight: "calc(85vh - 140px)",
                    paddingRight: "8px",
                  }}
                >
                  <div className="col-md-6">
                    <label className="form-label fs-12">
                      Entity Name <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select fs-12"
                      name="company_name"
                      value={addFormData.company_name}
                      onChange={handleAddFormChange}
                    >
                      <option value="">Select Entity</option>
                      {companies.map((c) => (
                        <option key={c} value={c}>
                          {c}
                        </option>
                      ))}
                    </select>
                    {addFormErrors.company_name && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.company_name}
                      </p>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fs-12">
                      Branch ID <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select fs-12"
                      name="branch_id"
                      value={addFormData.branch_id}
                      onChange={handleAddFormChange}
                    >
                      <option value="">Select Branch</option>
                      {availableBranchesForAdd.map((b) => (
                        <option key={b} value={b}>
                          {b}
                        </option>
                      ))}
                    </select>
                    {addFormErrors.branch_id && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.branch_id}
                      </p>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fs-12">
                      Location <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select fs-12"
                      name="location"
                      value={addFormData.location}
                      onChange={handleAddFormChange}
                    >
                      <option value="">Select Location</option>
                      {availableLocationsForAdd.map((loc) => (
                        <option key={loc} value={loc}>
                          {loc}
                        </option>
                      ))}
                    </select>
                    {addFormErrors.location && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.location}
                      </p>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fs-12">
                      Sub Branch <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select fs-12"
                      name="sub_branch"
                      value={addFormData.sub_branch}
                      onChange={handleAddFormChange}
                    >
                      <option value="">Select Sub Branch</option>
                      {availableSubBranches.map((sb) => (
                        <option key={sb} value={sb}>
                          {sb}
                        </option>
                      ))}
                    </select>
                    {addFormErrors.sub_branch && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.sub_branch}
                      </p>
                    )}
                  </div>

                  <div className="col-md-12">
                    <label className="form-label fs-12">
                      Legislation <span className="text-danger">*</span>
                    </label>
                    <input
                      list="add-legislation-list"
                      className="form-control fs-12"
                      name="legislation_name"
                      value={addFormData.legislation_name}
                      onChange={handleAddFormChange}
                      placeholder="Select or type legislation name"
                    />
                    <datalist id="add-legislation-list">
                      {availableActsForAdd.map((act) => (
                        <option key={act} value={act} />
                      ))}
                    </datalist>
                    {addFormErrors.legislation_name && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.legislation_name}
                      </p>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fs-12">
                      Compliance <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control fs-12"
                      name="compliance"
                      value={addFormData.compliance}
                      onChange={handleAddFormChange}
                      placeholder="Enter compliance"
                    />
                    {addFormErrors.compliance && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.compliance}
                      </p>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fs-12">
                      Due Date <span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      className="form-control fs-12"
                      name="due_date"
                      value={addFormData.due_date}
                      onChange={handleAddFormChange}
                    />
                    {addFormErrors.due_date && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.due_date}
                      </p>
                    )}
                  </div>

                  <div className="col-md-12">
                    <label className="form-label fs-12">
                      Compliance Description <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control fs-12"
                      name="compliance_description"
                      value={addFormData.compliance_description}
                      onChange={handleAddFormChange}
                      rows="2"
                      placeholder="Enter compliance description"
                    />
                    {addFormErrors.compliance_description && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.compliance_description}
                      </p>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fs-12">
                      Provision <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control fs-12"
                      name="provision"
                      value={addFormData.provision}
                      onChange={handleAddFormChange}
                      placeholder="Enter provision"
                    />
                    {addFormErrors.provision && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.provision}
                      </p>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fs-12">
                      Compliance Categorization <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control fs-12"
                      name="compliance_categorization"
                      value={addFormData.compliance_categorization}
                      onChange={handleAddFormChange}
                      placeholder="Enter categorization"
                    />
                    {addFormErrors.compliance_categorization && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.compliance_categorization}
                      </p>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fs-12">
                      Compliance Type <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control fs-12"
                      name="compliance_type"
                      value={addFormData.compliance_type}
                      onChange={handleAddFormChange}
                      placeholder="Enter compliance type"
                    />
                    {addFormErrors.compliance_type && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.compliance_type}
                      </p>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fs-12">
                      Current Compliance Status <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select fs-12"
                      name="current_compliance_status"
                      value={addFormData.current_compliance_status}
                      onChange={handleAddFormChange}
                    >
                      <option value="">Select Status</option>
                      {statusOptions.map((status) => (
                        <option key={status} value={status}>
                          {status}
                        </option>
                      ))}
                    </select>
                    {addFormErrors.current_compliance_status && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.current_compliance_status}
                      </p>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fs-12">
                      Penalty Type <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control fs-12"
                      name="penalty_type"
                      value={addFormData.penalty_type}
                      onChange={handleAddFormChange}
                      placeholder="Enter penalty type"
                    />
                    {addFormErrors.penalty_type && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.penalty_type}
                      </p>
                    )}
                  </div>

                  <div className="col-md-12">
                    <label className="form-label fs-12">
                      Penalty Description <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control fs-12"
                      name="penalty_description"
                      value={addFormData.penalty_description}
                      onChange={handleAddFormChange}
                      rows="2"
                      placeholder="Enter penalty description"
                    />
                    {addFormErrors.penalty_description && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.penalty_description}
                      </p>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fs-12">
                      Critical <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select fs-12"
                      name="criticality"
                      value={addFormData.criticality}
                      onChange={handleAddFormChange}
                    >
                      <option value="">Select</option>
                      <option value="High">High</option>
                      <option value="Medium">Medium</option>
                      <option value="Low">Low</option>
                    </select>
                    {addFormErrors.criticality && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.criticality}
                      </p>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fs-12">
                      Proof Mandatory <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select fs-12"
                      name="proof_mandatory"
                      value={addFormData.proof_mandatory}
                      onChange={handleAddFormChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                    {addFormErrors.proof_mandatory && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.proof_mandatory}
                      </p>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fs-12">
                      Auditor <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select fs-12"
                      name="auditor"
                      value={addFormData.auditor}
                      onChange={handleAddFormChange}
                    >
                      <option value="">Select Auditor</option>
                      {availableAuditorsForAdd.map((name) => (
                        <option key={name} value={name}>
                          {name}
                        </option>
                      ))}
                    </select>
                    {addFormErrors.auditor && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.auditor}
                      </p>
                    )}
                    {!addFormErrors.auditor &&
                      addFormData.branch_id &&
                      availableAuditorsForAdd.length === 0 && (
                        <p className="text-muted mb-0" style={{ fontSize: "12px" }}>
                          No assigned auditor found for this branch.
                        </p>
                      )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fs-12">
                      Approver <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select fs-12"
                      name="approver"
                      value={addFormData.approver}
                      onChange={handleAddFormChange}
                    >
                      <option value="">Select Approver</option>
                      {availableApproversForAdd.map((name) => (
                        <option key={name} value={name}>
                          {name}
                        </option>
                      ))}
                    </select>
                    {addFormErrors.approver && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.approver}
                      </p>
                    )}
                    {!addFormErrors.approver &&
                      addFormData.branch_id &&
                      availableApproversForAdd.length === 0 && (
                        <p className="text-muted mb-0" style={{ fontSize: "12px" }}>
                          No assigned approver found for this branch.
                        </p>
                      )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fs-12">
                      Open / Closed <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select fs-12"
                      name="open_closed"
                      value={addFormData.open_closed}
                      onChange={handleAddFormChange}
                    >
                      <option value="">Select</option>
                      <option value="0">Open</option>
                      <option value="1">Closed</option>
                    </select>
                    {addFormErrors.open_closed && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.open_closed}
                      </p>
                    )}
                  </div>

                  <div className="col-md-12">
                    <label className="form-label fs-12">
                      Summary of Observation <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control fs-12"
                      name="summary_of_observation"
                      value={addFormData.summary_of_observation}
                      onChange={handleAddFormChange}
                      rows="2"
                      placeholder="Enter summary of observation"
                    />
                    {addFormErrors.summary_of_observation && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.summary_of_observation}
                      </p>
                    )}
                  </div>

                  <div className="col-md-12">
                    <label className="form-label fs-12">
                      Management Remarks <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control fs-12"
                      name="management_remark"
                      value={addFormData.management_remark}
                      onChange={handleAddFormChange}
                      rows="2"
                      placeholder="Enter management remarks"
                    />
                    {addFormErrors.management_remark && (
                      <p className="text-danger mb-0" style={{ fontSize: "12px" }}>
                        {addFormErrors.management_remark}
                      </p>
                    )}
                  </div>
                </div>

                <div className="d-flex justify-content-end gap-2 mt-3 pt-2 border-top">
                  <button
                    type="button"
                    className="btn btn-outline-dark px-4 fs-12"
                    onClick={() => {
                      setShowAddComplianceModal(false);
                      resetAddComplianceForm();
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-dark px-4 fs-12"
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Save Compliance"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <div className="d-flex justify-content-between align-items-center mt-4">
        <div>
          <select
            className="form-select form-select-sm w-auto"
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
          >
            {[8, 20, 30, 50].map((size) => (
              <option key={size} value={size} className="fs-12">
                {size} per page
              </option>
            ))}
          </select>
        </div>
        <nav>
          <ul className="pagination mb-0 d-flex align-items-center gap-2">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link text-dark border-0 bg-transparent"
                onClick={handlePrevious}
              >
                Previous
              </button>
            </li>
            {startPage > 1 && (
              <li className="page-item disabled">
                <span className="page-link border-0 bg-transparent">...</span>
              </li>
            )}
            {pageNumbers.map((pageNum) => (
              <li
                key={pageNum}
                className={`page-item ${currentPage === pageNum ? "active" : ""
                  }`}
              >
                {/* <button
                  className={`page-link ${currentPage === pageNum ? "bg-dark text-white border-0 " : "text-dark border-0 bg-transparent"}`}
                  onClick={() => handlePageChange(pageNum)}
                > */}
                <button
                  className={`page-link d-flex justify-content-center align-items-center ${currentPage === pageNum
                    ? "bg-dark text-white"
                    : "text-dark bg-transparent"
                    }`}
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    border: "1px solid #dee2e6",
                    padding: 0,
                    margin: "0 4px",
                  }}
                  onClick={() => handlePageChange(pageNum)}
                >
                  {pageNum}
                </button>
              </li>
            ))}
            {endPage < totalPages && (
              <li className="page-item disabled">
                <span className="page-link border-0 bg-transparent">...</span>
              </li>
            )}

            <li
              className={`page-item ${currentPage === totalPages ? "disabled" : ""
                }`}
            >
              <button
                className="page-link text-dark border-0 bg-transparent"
                onClick={handleNext}
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </section>
  );
}
export default Active;
